const numberOpFunc = (_category) => ['==', '>', '<']

export const filter_options = [
    // {
    //     columnField: "video_uid",
    //     type: "text",
    //     customOperatorFunc: (_category) => ['==', "!="]
    // },
    {
        columnField: "benchmarks",
        type: "array[text]",
        customOperatorFunc: (_category) => ['include', '!include'],
        customValuesFunc: (_c, _o) => benchmark_values,
    },
    {
        columnField: "modalities",
        type: "array[text]",
        customOperatorFunc: (_category) => ['include', '!include'],
        customValuesFunc: (_c, _o) => modality_values,
    },
    // {
    //     columnField: "narrations",
    //     type: "array[text]",
    //     customOperatorFunc: (_c) => ['contain', '!contain'],
    // },
    {
        columnField: "scenarios",
        type: "array[text]",
        customOperatorFunc: (_category) => ['include', '!include'],
        customValuesFunc: (_c, _o) => scenario_values,
    },
    {
        columnField: "vq.objects",
        type: "array[text]",
        customOperatorFunc: (_category) => ['include', '!include'],
        customValuesFunc: (_c, _o) => vq_object_values,
    },
    {
        columnField: 'moments.activities',
        type: "array[text]",
        customOperatorFunc: (_c) => ['include', '!include'],
        customValuesFunc: (_c, _o) => moments_activity_values,
    },
    {
        columnField: 'nlq.query_templates',
        type: "array[text]",
        customOperatorFunc: (_c) => ['include', '!include'],
        customValuesFunc: (_c, _o) => nlq_query_template_values,
    },
    {
        columnField: "fho_lta.action_nouns",
        type: "array[text]",
        customOperatorFunc: (_category) => ['include', '!include'],
        customValuesFunc: (_c, _o) => fho_lta_action_noun_values,
    },
    {
        columnField: "fho_lta.action_verbs",
        type: "array[text]",
        customOperatorFunc: (_category) => ['include', '!include'],
        customValuesFunc: (_c, _o) => fho_lta_action_verb_values,
    },
    {
        columnField: "fho_scod.objects",
        type: "array[text]",
        customOperatorFunc: (_category) => ['include', '!include'],
        customValuesFunc: (_c, _o) => fho_scod_object_values,
    },
    {
        columnField: "fho_sta.objects",
        type: "array[text]",
        customOperatorFunc: (_category) => ['include', '!include'],
        customValuesFunc: (_c, _o) => fho_sta_object_values,
    },
    {
        columnField: "fho_sta.verbs",
        type: "array[text]",
        customOperatorFunc: (_category) => ['include', '!include'],
        customValuesFunc: (_c, _o) => fho_sta_verb_values,
    },
    // {
    //     columnField: "summaries",
    //     type: "array[text]",
    //     customOperatorFunc: (_c) => ['contain', '!contain'],
    // },
    {
        columnField: "is_stereo",
        type: "text",
        customOperatorFunc: (_category) => ['==', "!="],
        customValuesFunc: (_c, _o) => ['true', 'false'],
    },
    {
        columnField: "split_av",
        type: "text",
        customOperatorFunc: (_c) => ['==', '!='],
        customValuesFunc: (_c, _o) => ['test', 'train', 'val'],
    },
    {
        columnField: "split_em",
        type: "text",
        customOperatorFunc: (_c) => ['==', '!='],
        customValuesFunc: (_c, _o) => ['test', 'train', 'val'],
    },
    {
        columnField: "split_fho",
        type: "text",
        customOperatorFunc: (_c) => ['==', '!='],
        customValuesFunc: (_c, _o) => ['test', 'train', 'val', 'multi'],
    },
    {
        columnField: "splits",
        type: "array[text]",
        customOperatorFunc: (_category) => ['include', '!include'],
        customValuesFunc: (_c, _o) => split_values,
    },
    {
        columnField: "device",
        type: "text",
        customOperatorFunc: (_category) => ['==', "!="],
        customValuesFunc: (_c, _o) => device_values,
    },
    {
        columnField: "physical_setting_name",
        type: "text",
        customOperatorFunc: (_category) => ['==', "!="],
        customValuesFunc: (_c, _o) => physical_setting_name_values,
    },
    {
        columnField: "dimensions",
        type: "text",
        customOperatorFunc: (_category) => ['==', "!="],
        customValuesFunc: (_c, _o) => dimension_values,
    },
    {
        columnField: "duration",
        type: "number",
        customOperatorFunc: numberOpFunc
    },
    {
        columnField: "num_frames",
        type: "number",
        customOperatorFunc: numberOpFunc
    },
    {
        columnField: "video_source",
        type: "text",
        customOperatorFunc: (_category) => ['==', "!="],
        customValuesFunc: (_c, _o) => video_source_values,
    },
];

export const moments_activity_values = [
    'apply_fertilizer_/_pesticide_by_hands_or_other_equipment',
    'apply_fertilizer_/_pesticide_with_sprayer',
    'arrange_/_organize_books_on_shelf',
    'arrange_/_organize_clothes_in_closet/dresser',
    'arrange_/_organize_furniture',
    'arrange_/_organize_items_in_fridge',
    'arrange_/_organize_other_items',
    'arrange_pillows_on_couch_/_chair',
    'assemble_a_salad',
    'assemble_a_sandwich',
    'beat_/_whisk_eggs_in_a_bowl',
    'blend_ingredients_using_an_electric_blender',
    'boil_rice_/_pasta_/_noodles',
    'boil_some_other_food_item',
    'break_eggs_into_a_bowl',
    'browse_through_accessories_on_rack_/_shelf',
    'browse_through_clothing_items_on_rack_/_shelf_/_hanger',
    'browse_through_groceries_or_food_items_on_rack_/_shelf',
    'browse_through_other_items_on_rack_/_shelf',
    'carve_wood_with_chisel,_carving_machine,_etc.',
    'charge_electronic_device',
    'chop_/_cut_wood_pieces_using_tool',
    'clean_/_arrange_shoes',
    'clean_/_empty_litterbox',
    'clean_/_empty_the_vacuum_cleaner',
    'clean_/_repair_small_equipment_(mower,_trimmer_etc.)',
    'clean_/_sweep_floor_with_broom',
    'clean_/_wipe_/_oil_metallic_item',
    'clean_/_wipe_a_table_or_kitchen_counter',
    'clean_/_wipe_kitchen_appliance',
    'clean_/_wipe_other_surface_or_object',
    'clean_hand_with_hand_sanitizer',
    'clean_something_with_air_blower',
    'clean_the_bathtub',
    'clean_the_sink',
    'clean_toilet_bowl',
    'clean_window',
    'climb_up_/_down_a_ladder',
    'collect_/_rake_dry_leaves_on_ground',
    'collect_firewood',
    'compare_two_clothing_items',
    'converse_/_interact_with_someone',
    'count_money_before_paying',
    'cross_the_road',
    'cut_/_chop_/_slice_a_vegetable,_fruit,_or_meat',
    'cut_/_trim_grass_with_a_lawnmower',
    'cut_/_trim_grass_with_other_tools',
    'cut_dough',
    'cut_metal_using_tool',
    'cut_open_a_package_(e.g._with_scissors)',
    'cut_other_item_using_tool',
    'cut_pipe_using_tool',
    'cut_straw/hay_with_sickle',
    'cut_thread_/_paper_/_cardboard_using_scissors_/_knife_/_cutter',
    'cut_tree_branch',
    'dance_to_music',
    'decorate_a_cake_/_cookie',
    'dig_or_till_the_soil_by_hand',
    'dig_or_till_the_soil_with_a_hoe_or_other_tool',
    'dismantle_a_bicycle',
    'dismantle_furniture_items',
    'dismantle_other_item',
    'do_some_exercise',
    'drill_into_wall_/_wood_/_floor_/_metal',
    'drink_beverage',
    'drive_a_vehicle',
    'eat_a_snack',
    'enter_a_supermarket_/_shop',
    'exit_a_supermarket_/_shop',
    'feed_pet_/_animal',
    'fill_a_bucket_with_water_from_a_tap_or_well',
    'fill_a_pot_/_bottle_/_container_with_water',
    'fix_/_remove_/_replace_a_tire_or_wheel',
    'fix_/_tile_the_floor',
    'fix_bicycle_/_bike_/_motorcycle_chain',
    'fix_bike_/_motorcycle_engine',
    'fix_bonnet_/_engine_of_car',
    'fix_furniture',
    'fix_metal_surface_using_electric_torch',
    'fix_other_item',
    'fix_pipe_/_plumbing',
    'fix_the_break_on_bike',
    'fix_wiring',
    'fold_clothes_/_sheets',
    'fry_dough',
    'fry_egg',
    'fry_meat',
    'fry_other_food_item',
    'gather_/_pack_bales_of_hay_or_straw',
    'gather_dirty_laundry',
    'grate_vegetables_or_other_ingredient',
    'grind_ingredients_/_spices',
    'hang_clothes_in_closet_/_on_hangers',
    'hang_clothes_to_dry',
    'harvest_vegetables_/_fruits_/_crops_from_plants_on_the_ground',
    'harvest_vegetables_/_fruits_/_crops_from_trees',
    'interact_or_play_with_pet_/_animal',
    'iron_clothes_or_sheets',
    'knead_/_shape_/_roll-out_dough',
    'level_ground_/_soil_(eg._using_rake,_shovel,_etc)',
    'load/unload_the_dishwasher',
    'load_/_unload_a_washing_machine_or_dryer',
    'look_at_clothes_in_the_mirror',
    'make_coffee_or_tea_/_use_a_coffee_machine',
    'make_pancakes',
    'make_the_bed_/_arrange_pillows,_sheets_etc._on_bed',
    'make_toast_/_use_a_toaster',
    'mark_item_with_pencil_/_pen_/_marker',
    'measure_bricks_using_tape_/_ruler',
    'measure_ingredient_in_a_measuring_cup_or_spoon',
    'measure_other_item_using_tape_/_ruler',
    'measure_site_using_laser_level',
    'measure_tile_using_tape_/_ruler',
    'measure_wall_/_ceiling_/_flooring_using_tape,_ruler',
    'measure_wooden_item_using_tape_/_ruler',
    'mop_the_floor',
    'move_/_shift_/_arrange_small_tools',
    'move_/_shift_around_construction_material',
    'open_a_can_with_a_can_opener',
    'operate_a_dough_mixing_machine',
    'operate_a_forklift',
    'operate_a_water_hose',
    'pack_bag/sack_with_crops_or_grass',
    'pack_food_items_/_groceries_into_bags_/_boxes',
    'pack_other_items_into_bags_/_boxes',
    'pack_soil_into_the_ground_or_a_pot_/_container',
    'paint_using_paint_brush_/_roller',
    'pay_at_billing_counter',
    'peel_a_fruit_or_vegetable',
    'place_items_in_shopping_cart',
    'plant_seeds_/_plants_/_flowers_into_ground',
    'plaster_wall_/_surface',
    'play_a_video_game',
    'play_board_game_or_card_game',
    'play_the_piano',
    'prepare_or_apply_cement_/_concrete_/_mortar',
    'pump_/_fill_/_pressurize_a_tire',
    'put_away_(or_take_out)_dishes_/_utensils_in_storage',
    'put_away_(or_take_out)_food_items_in_the_fridge',
    'put_away_(or_take_out)_ingredients_in_storage',
    'put_food_into_the_oven_to_bake',
    'put_fuel_in_stove_/_fireplace',
    'put_on_/_take_off_an_apron',
    'put_on_safety_equipment_(e.g._gloves,_helmet,_safety_goggles)',
    'put_up_decorations_in_a_room',
    're-fuel_vehicle_/_equipment',
    'read_a_book_/_magazine_/_shopping_list_etc.',
    'refill_water/chemical_into_sprayer',
    'remove_food_from_the_oven',
    'remove_husk_from_crops',
    'remove_paint_from_wall_/_ceiling_/_furniture',
    'remove_weeds_from_ground',
    'request_and_eat_a_food_sample',
    'rinse_/_drain_noodles_in_sieve_/_colander',
    'rinse_/_drain_other_food_item_in_sieve_/_colander',
    'serve_food_onto_a_plate',
    'set_the_table',
    'sew_/_knit_/_crochet_/_mend_some_fabric',
    'sharpen_knife_/_blade_/_cutter',
    'sift_ingredients',
    'smoke_cigar_/_cigarette_/_vape',
    'smooth_floor_surface_using_trowel',
    'smooth_other_surface_(eg._using_sandpaper)',
    'smooth_wood_using_sandpaper_/_sander_/_tool',
    'sort_trash_/_recycling_material',
    'spread_cheese_/_jelly_/_butter_/_etc._on_bread',
    'squeeze_juice_from_a_fruit_(lemon,_lime,_etc.)',
    'stand_in_the_queue_/_line_at_a_shop_/_supermarket',
    'stick_items_together_using_glue_/_staple_/_tape_/_adhesive',
    'stir_/_mix_food_while_cooking',
    'stir_/_mix_ingredients_in_a_bowl_or_pan_(before_cooking)',
    'store_leftover_food_in_box_/_container',
    'take_off_clothing_item',
    'take_out_the_trash_/_empty_the_trash_bin',
    'take_photo_/_record_video_with_a_camera',
    'taste_food_while_cooking',
    'throw_away_trash_/_put_trash_in_trash_can',
    'tie_up_branches_/_plants_with_string',
    'trim_hedges_or_branches',
    'try-out_/_wear_accessories_(e.g._tie,_belt,_scarf)',
    'try-out_/_wear_clothing_items_(e.g._shirt,_jeans,_sweater)',
    'turn-on_/_light_the_stove_burner',
    'use_a_laptop_/_computer',
    'use_a_pressure_cooker_/_instant_pot',
    'use_a_vacuum_cleaner_to_clean',
    'use_hammer_/_nail-gun_to_fix_nail',
    'use_leveler_to_balance_surface',
    'use_other_kitchen_appliance',
    'use_phone',
    'use_the_microwave_/_warm_something_in_the_microwave',
    'walk_down_stairs_/_walk_up_stairs',
    'walk_the_dog_/_pet',
    'wash_clothes_by_hand',
    'wash_dishes_/_utensils_/_bakeware_etc.',
    'wash_hands',
    'wash_vegetable_/_fruit_/_food_item',
    'watch_television',
    'water_soil_/_plants_/_crops',
    'weigh_food_/_ingredient_using_a_weighing_scale',
    'weld_metallic_item',
    'withdraw_money_from_atm_/_operate_atm',
    'wrap_food_in_paper_/_foil_/_plastic',
    'write_notes_in_a_paper_/_book'
];

export const nlq_query_template_values = [
    'Objects: How many X’s? (quantity question)',
    'Objects: In what location did I see object X ?',
    'Objects: State of an object',
    'Objects: What X did I Y?',
    'Objects: What X is Y?',
    'Objects: What did I put in X?',
    'Objects: Where is my object X?',
    'Objects: Where is object X before / after event Y?',
    'Objects: Where is object X?',
    'People: When did I talk to or interact with person with role X?',
    'People: Who did I interact with when I did activity X?',
    'People: Who did I talk to in location X?',
    'Place: Where did I put X?'
];

export const fho_sta_verb_values = [
    'adjust_(regulate,_increase/reduce,_change)',
    'apply_(spread,_smear)',
    'arrange_(straighten,_sort,_distribute,_align)',
    'attach_(plug-in,_join,_fasten,_connect,_attach)',
    'clean_(sweep,_scrub,_mop,_dust)',
    'climb',
    'close',
    'consume_(taste,_sip,_eat,_drink)',
    'cut_(trim,_slice,_chop)',
    'detach_(unplug,_unhook,_disconnect)',
    'dig',
    'dip',
    'divide_(split,_separate)',
    'drill',
    'drive_(ride,_drive)',
    'file_(with_tool)',
    'fill',
    'fold',
    'give',
    'grate',
    'hang',
    'hit_(knock,_hit,_hammer)',
    'hold_(support,_grip,_grasp)',
    'insert',
    'inspect_(check,_look,_examine,_view)',
    'iron',
    'kick',
    'knead',
    'loosen',
    'mark',
    'measure_(weigh,_measure)',
    'mold',
    'move_(transfer,_pass,_exchange)',
    'open',
    'operate_(use,_dial,_click-button)',
    'pack',
    'paint_draw',
    'peel',
    'plant',
    'play',
    'pour',
    'press_push',
    'pump',
    'put_(place,_leave,_drop)',
    'repair',
    'roll',
    'sand',
    'scoop',
    'scrape',
    'screw',
    'scroll',
    'search_inspect',
    'serve',
    'sew_(weave,_stitch,_sew)',
    'shake',
    'shuffle',
    'smooth',
    'spray',
    'squeeze',
    'stick_(tape,_stick,_glue)',
    'take_(pick,_grab,_get)',
    'throw_(toss,_dump,_dispose)',
    'tie',
    'tighten',
    'touch',
    'turn_(spin,_rotate,_flip,_turn_over)',
    'turn_off_(turn_off,_switch_off)',
    'turn_on_(switch_on,_start,_light)',
    'unscrew',
    'water',
    'weld',
    'write'
];

export const fho_sta_object_values = [
    'artwork_(art,_draw,_drawing,_painting,_sketch)',
    'bag_(bag,_grocery,_nylon,_polythene,_pouch,_sachet,_sack,_suitcase)',
    'ball_(ball,_baseball,_basketball)',
    'bicycle_(bicycle,_bike)',
    'book_(book,_booklet,_magazine,_manual,_notebook,_novel,_page,_textbook)',
    'bottle_(bottle,_flask)',
    'bowl',
    'brick',
    'broom_(broom,_broomstick)',
    'brush',
    'bucket',
    'cabinet_(cabinet,_compartment,_cupboard)',
    'caliper',
    'car_(car,_vehicle)',
    'cement_(cement,_concrete,_mortar)',
    'computer_(computer,_ipad,_laptop,_motherboard,_screen)',
    'container_(box,_can,_carton,_case,_casing,_container,_crate,_holder,_jar,_jerrycan,_keg,_pack,_package,_packaging,_packet,_storage,_tank,_tin)',
    'cooker',
    'cup_(cup,_mug,_tumbler)',
    'cutter_(tool)',
    'door',
    'dough',
    'drawer',
    'drill_(drill,_driller)',
    'dumbbell',
    'engine_(assembly,_carburetor,_engine,_motor)',
    'faucet_(faucet,_tap)',
    'floor_(floor,_ground)',
    'flower',
    'food',
    'fridge_(fridge,_refrigerator)',
    'glass',
    'glue_(adhesive,_glue,_gum,_sealant)',
    'hammer_(hammer,_mallet)',
    'indument',
    'jug',
    'knife_(knife,_machete)',
    'lid_(cap,_cover,_lid)',
    'mask',
    'mat_(mat,_rug)',
    'metal_(lead,_metal,_steel)',
    'mold_(mold,_molder,_mould)',
    'mop',
    'mower_(lawnmower,_mower)',
    'napkin_(handkerchief,_napkin,_serviette,_tissue,_wipe)',
    'needle_(hook,_needle)',
    'nut_(tool)',
    'paint',
    'pan_(frypan,_pan,_saucepan)',
    'paper_(chart,_craft,_newspaper,_note,_paper,_papercraft,_poster,_receipt)',
    'pedal',
    'pen_(marker,_pen)',
    'phone_(cellphone,_phone,_smartphone)',
    'plant',
    'plate_(dish,_plate,_platter,_saucer)',
    'playing_cards',
    'pot',
    'pump',
    'rod_(dipstick,_rod,_rod_metal,_shaft)',
    'rope',
    'rubber_band',
    'saw_(chainsaw,_saw,_hacksaw)',
    'scissors',
    'screw_(bolt,_nail,_screw)',
    'screwdriver',
    'shelf',
    'shoe_(boot,_sandal,_shoe,_slipper)',
    'sickle',
    'sieve_(sieve,_strainer)',
    'spatula',
    'sponge_(scrubber,_sponge)',
    'spoon',
    'stone_(rock,_stone)',
    'string_(bobbin,_knot,_lace,_ribbon,_spool,_strand,_string,_thread,_twine,_wool,_yarn)',
    'table_(stand,_table)',
    'tablet',
    'tape_measure_(measure,_measurement)',
    'tile',
    'towel',
    'trash',
    'tray',
    'vegetable_fruit',
    'wall',
    'wheel',
    'wire_(adapter,_cable,_charger,_connector,_cord,_wire)',
    'wood_(fiber,_firewood,_floorboard,_log,_lumber,_plank,_plywood,_timber,_wood,_woodcraft,_woodwork)',
    'wrench'
];

export const fho_scod_object_values = [
    'apron',
    'artwork_(art,_draw,_drawing,_painting,_sketch)',
    'asparagus',
    'avocado',
    'awl',
    'axe',
    'baby',
    'bacon',
    'bag_(bag,_grocery,_nylon,_polythene,_pouch,_sachet,_sack,_suitcase)',
    'baking_soda',
    'ball_(ball,_baseball,_basketball)',
    'ball_bearing',
    'banana_(banana,_plantain)',
    'bar',
    'baseboard',
    'basket',
    'bat_(sports)',
    'bat_(tool)',
    'batter_(batter,_mixture)',
    'battery',
    'bead',
    'beaker',
    'bean',
    'bed',
    'belt',
    'bench',
    'berry',
    'beverage_(drink,_juice,_beer,_beverage,_champagne)',
    'bicycle_(bicycle,_bike)',
    'blanket_(bedsheet,_blanket,_duvet)',
    'blender',
    'block_(material)',
    'blower',
    'bolt_extractor',
    'book_(book,_booklet,_magazine,_manual,_notebook,_novel,_page,_textbook)',
    'bookcase',
    'bottle_(bottle,_flask)',
    'bowl',
    'bracelet_(bangle,_bracelet)',
    'brake_(brake,_break)',
    'brake_pad',
    'branch',
    'bread_(bread,_bun,_chapati,_flatbread,_loaf,_roti,_tortilla)',
    'brick',
    'broccoli',
    'broom_(broom,_broomstick)',
    'brush',
    'bucket',
    'buckle',
    'butter',
    'button',
    'cabbage',
    'cabinet_(cabinet,_compartment,_cupboard)',
    'calculator',
    'caliper',
    'camera',
    'can_opener',
    'canvas',
    'car_(car,_vehicle)',
    'card',
    'cardboard_(cardboard,_paperboard)',
    'carpet',
    'carrot',
    'cart_(cart,_trolley)',
    'ceiling',
    'celery',
    'cello',
    'cement_(cement,_concrete,_mortar)',
    'cereal',
    'chaff',
    'chain',
    'chair',
    'chalk',
    'cheese',
    'chicken',
    'chip_(food)',
    "chip_(wood'_metal),",
    'chip_(wood,_metal)',
    'chisel',
    'chocolate',
    'chopping_board',
    'chopstick',
    'cigarette_(cigarette,_vape)',
    'circuit',
    'clamp',
    'clay',
    'clip',
    'clock',
    'cloth_(cloth,_fabric,_garment,_kanga,_rag)',
    'coffee',
    'coffee_machine',
    'colander',
    'comb',
    'computer_(computer,_ipad,_laptop,_motherboard,_screen)',
    'container_(box,_can,_carton,_case,_casing,_container,_crate,_holder,_jar,_jerrycan,_keg,_pack,_package,_packaging,_packet,_storage,_tank,_tin)',
    'cooker',
    'corn',
    'corner',
    'countertop_(counter,_countertop)',
    'cracker_(biscuit,_cracker)',
    'cream',
    'crochet',
    'crowbar',
    'cucumber',
    'cup_(cup,_mug,_tumbler)',
    'curtain',
    'cutter_(tool)',
    'decoration_(decoration,_ornament)',
    'derailleur',
    'detergent',
    'dice_(dice,_die)',
    'dishwasher',
    'dog',
    'door',
    'dough',
    'dough_mixer',
    'doughnut',
    'drawer',
    'dress',
    'drill_(drill,_driller)',
    'drill_bit',
    'drum',
    'dumbbell',
    'dust_(dust,_sawdust)',
    'dustpan',
    'egg',
    'engine_(assembly,_carburetor,_engine,_motor)',
    'envelope_(envelop,_envelope)',
    'eraser_(eraser,_rubber)',
    'facemask',
    'fan',
    'faucet_(faucet,_tap)',
    'fence',
    'file_(tool)',
    'filter',
    'fish',
    'fishing_rod',
    'floor_(floor,_ground)',
    'flour',
    'flower',
    'foam',
    'foil',
    'food',
    'foot_(foot,_toe)',
    'fork',
    'fridge_(fridge,_refrigerator)',
    'fries',
    'fuel',
    'funnel',
    'game_controller',
    'garbage_can_(bin,_dustbin)',
    'garlic',
    'gasket',
    'gate',
    'gauge',
    'gauze',
    'gear',
    'generator',
    'ginger',
    'glass',
    'glasses_(goggle,_shade,_spectacle,_sunglass)',
    'glove',
    'glue_(adhesive,_glue,_gum,_sealant)',
    'glue_gun',
    'golf_club',
    'gourd',
    'grain',
    'grapefruit',
    'grass',
    'grater',
    'grill',
    'grinder',
    'guava',
    'guitar',
    'hair',
    'hammer_(hammer,_mallet)',
    'hand_(finger,_hand,_palm,_thumb)',
    'handle',
    'hanger',
    'hat',
    'hay',
    'haystack',
    'head',
    'headphones_(earphone,_headphone)',
    'heater',
    'helmet',
    'hinge',
    'hole',
    'hose',
    'ice',
    'ice_cream',
    'ink',
    'iron',
    'jack_(tool)_(jack,_lift)',
    'jacket_(coat,_jacket)',
    'jug',
    'ketchup',
    'kettle',
    'key',
    'keyboard',
    'knife_(knife,_machete)',
    'label_(label,_tag)',
    'ladder',
    'leaf_(leaf,_leave)',
    'leash',
    'leg_(knee,_leg,_thigh)',
    'lever',
    'lid_(cap,_cover,_lid)',
    'light_(bulb,_flashlight,_lamp,_light)',
    'lighter',
    'lime',
    'lock',
    'lubricant_(grease,_lubricant)',
    'magnet_(magnet,_sphere)',
    'manure_(dung,_manure)',
    'mask',
    'mat_(mat,_rug)',
    'matchstick',
    'meat_(beef,_ham,_meat)',
    'metal_(lead,_metal,_steel)',
    'microscope',
    'microwave',
    'milk',
    'mirror',
    'mixer',
    'mold_(mold,_molder,_mould)',
    'money_(cash,_coin,_money)',
    'mop',
    'motorcycle_(motorbike,_motorcycle)',
    'mouse_(computer)',
    'mouth',
    'mower_(lawnmower,_mower)',
    'multimeter',
    'mushroom',
    'nail_cutter',
    'nail_gun',
    'nail_polish',
    'napkin_(handkerchief,_napkin,_serviette,_tissue,_wipe)',
    'needle_(hook,_needle)',
    'net',
    'nozzle',
    'nut_(food)',
    'nut_(tool)',
    'oil_(fat,_oil)',
    'okra',
    'onion',
    'oven',
    'paddle',
    'paint',
    'paint_roller',
    'paintbrush',
    'palette',
    'pan_(frypan,_pan,_saucepan)',
    'pancake',
    'panel',
    'pants_(jean,_pant,_short,_trouser)',
    'paper_(chart,_craft,_newspaper,_note,_paper,_papercraft,_poster,_receipt)',
    'pasta_(noodle,_pasta,_spaghetti)',
    'paste',
    'pastry',
    'pea',
    'peanut',
    'pear',
    'pedal',
    'peel',
    'peeler',
    'peg',
    'pen_(marker,_pen)',
    'pencil',
    'pepper_(vegetable)_(capsicum,_pepper)',
    'phone_(cellphone,_phone,_smartphone)',
    'photo',
    'piano',
    'picture_(picture,_portrait)',
    'pillow',
    'pilot_jet',
    'pin',
    'pipe',
    'pizza',
    'planer_(plane,_planer)',
    'plant_(bud,_frond,_plant,_reed,_seedling,_shrub,_stem,_vine,_weed)',
    'plate_(dish,_plate,_platter,_saucer)',
    'playing_cards',
    'plier',
    'plug',
    'pole',
    'popcorn',
    'pot',
    'pot_(planter)',
    'potato',
    'pump',
    'pumpkin',
    'purse',
    'puzzle_or_game_piece_(chess,_domino,_jenga,_jigsaw,_pawn,_puzzle)',
    'rack',
    'radio',
    'rail_(rail,_railing)',
    'rake',
    'razor_blade',
    'remote_control_(control,_remote)',
    'rice',
    'ring',
    'rod_(dipstick,_rod,_rod_metal,_shaft)',
    'rolling_pin',
    'root',
    'rope',
    'router',
    'rubber_band',
    'ruler_(rule,_ruler)',
    'sand',
    'sander',
    'sandpaper',
    'sauce',
    'sausage',
    'saw_(chainsaw,_saw,_hacksaw)',
    'scarf_(scarf,_shawl)',
    'scissors',
    'scoop_(scoop,_scooper)',
    'scraper_(scraper,_scrapper)',
    'screw_(bolt,_nail,_screw)',
    'screwdriver',
    'sculpture',
    'seasoning_(salt,_seasoning,_shaker,_spice,_sugar)',
    'seed',
    'set_square_(tool)',
    'sewing_machine',
    'shears',
    'sheet',
    'shelf',
    'shirt_(cardigan,_shirt,_sweater,_sweatshirt,_top)',
    'shoe_(boot,_sandal,_shoe,_slipper)',
    'shovel_(hoe,_shovel,_spade)',
    'sickle',
    'sieve_(sieve,_strainer)',
    'sink_(basin,_sink)',
    'sketch_pad',
    'skirt',
    'slab',
    'snorkel',
    'soap',
    'sock',
    'socket',
    'soil_(dirt,_mud,_soil)',
    'solder_iron',
    'soup',
    'spatula',
    'speaker',
    'sphygmomanometer',
    'spice',
    'spinach',
    'spirit_level',
    'sponge_(scrubber,_sponge)',
    'spoon_(spoon,_spoonful)',
    'spray_(spray,_sprayer)',
    'spring',
    'squeezer',
    'stairs_(stair,_staircase)',
    'stamp',
    'stapler',
    'steamer',
    'steering_wheel',
    'stick_(stick,_twig)',
    'sticker',
    'stock_(food)',
    'stone_(rock,_stone)',
    'stool',
    'stove_(burner,_gas,_stove)',
    'strap',
    'straw',
    'string_(bobbin,_knot,_lace,_ribbon,_spool,_strand,_string,_thread,_twine,_wool,_yarn)',
    'switch_(knob,_switch)',
    'syringe',
    'table_(stand,_table)',
    'tablet',
    'tape_(cellotape,_sellotape,_tape)',
    'tape_measure_(measure,_measurement)',
    'tea',
    'teapot',
    'television_(television,_tv)',
    'test_tube',
    'tie',
    'tile',
    'timer',
    'toaster',
    'tomato',
    'tongs',
    'toolbox',
    'toothbrush',
    'toothpick',
    'torch_(torch,_torchlight)',
    'towel',
    'toy_(doll,_toy)',
    'tractor',
    'trash_(debris,_garbage,_litter,_trash,_waste)',
    'tray',
    'treadmill',
    'tree',
    'trimmer_(pruner,_trimmer)',
    'trowel',
    'truck',
    'tweezer',
    'umbrella',
    'undergarment_(boxer,_bra)',
    'vacuum',
    'vacuum_cleaner',
    'valve',
    'vase',
    'wall',
    'wallet',
    'wallpaper',
    'washing_machine',
    'watch',
    'water',
    'watermelon',
    'weighing_scale',
    'welding_torch',
    'wheat_(maize,_wheat)',
    'wheel_(tyre,_wheel)',
    'whisk',
    'window',
    'windshield',
    'wiper_(car)',
    'wire_(adapter,_cable,_charger,_connector,_cord,_wire)',
    'wood_(fiber,_firewood,_floorboard,_log,_lumber,_plank,_plywood,_timber,_wood,_woodcraft,_woodwork)',
    'worm',
    'wrapper_(covering,_film,_seal,_wrap,_wrapper,_wrapping)',
    'wrench_(spanner,_wrench)',
    'yam',
    'yeast',
    'yoghurt',
    'zipper_(zip,_zipper)',
    'zucchini'
];

export const fho_lta_action_verb_values = [
    'adjust_(regulate,_increase/reduce,_change)',
    'apply_(spread,_smear)',
    'arrange_(straighten,_sort,_distribute,_align)',
    'attach_(plug-in,_join,_fasten,_connect,_attach)',
    'blow',
    'break',
    'carry',
    'catch',
    'clap',
    'clean_(sweep,_scrub,_mop,_dust)',
    'climb',
    'close',
    'consume_(taste,_sip,_eat,_drink)',
    'count',
    'cover',
    'crochet',
    'cut_(trim,_slice,_chop)',
    'detach_(unplug,_unhook,_disconnect)',
    'dig',
    'dip',
    'divide_(split,_separate)',
    'draw',
    'drill',
    'drive_(ride,_drive)',
    'enter',
    'feed',
    'file_(with_tool)',
    'fill',
    'fold',
    'give',
    'grate',
    'grind',
    'hang',
    'hit_(knock,_hit,_hammer)',
    'hold_(support,_grip,_grasp)',
    'insert',
    'inspect_(check,_look,_examine,_view)',
    'iron',
    'kick',
    'knead',
    'knit',
    'lift',
    'lock',
    'loosen',
    'mark',
    'measure_(weigh,_measure)',
    'mix',
    'mold',
    'move_(transfer,_pass,_exchange)',
    'open',
    'operate_(use,_dial,_click-button)',
    'pack',
    'paint',
    'park',
    'peel',
    'pet',
    'plant',
    'play',
    'point',
    'pour',
    'press',
    'pull',
    'pump',
    'push',
    'put_(place,_leave,_drop)',
    'read',
    'remove',
    'repair',
    'roll',
    'sand',
    'scoop',
    'scrape',
    'screw',
    'scroll',
    'search',
    'serve',
    'sew_(weave,_stitch,_sew)',
    'shake',
    'sharpen',
    'shuffle',
    'sieve',
    'sit',
    'smooth',
    'spray',
    'sprinkle',
    'squeeze',
    'stand',
    'step',
    'stick_(tape,_stick,_glue)',
    'stretch',
    'swing',
    'take_(pick,_grab,_get)',
    'throw_(toss,_dump,_dispose)',
    'tie',
    'tighten',
    'tilt',
    'touch',
    'turn_(spin,_rotate,_flip,_turn_over)',
    'turn_off_(turn_off,_switch_off)',
    'turn_on_(switch_on,_start,_light)',
    'uncover',
    'unfold',
    'unroll',
    'unscrew',
    'untie',
    'walk',
    'wash',
    'water',
    'wear',
    'weld',
    'wipe',
    'write',
    'zip'
];

export const fho_lta_action_noun_values = [
    'apple',
    'apron',
    'arm',
    'artwork_(art,_draw,_drawing,_painting,_sketch)',
    'asparagus',
    'avocado',
    'awl',
    'axe',
    'baby',
    'bacon',
    'bag_(bag,_grocery,_nylon,_polythene,_pouch,_sachet,_sack,_suitcase)',
    'baking_soda',
    'ball_(ball,_baseball,_basketball)',
    'ball_bearing',
    'balloon',
    'banana_(banana,_plantain)',
    'bar',
    'baseboard',
    'basket',
    'bat_(sports)',
    'bat_(tool)',
    'bathtub',
    'batter_(batter,_mixture)',
    'battery',
    'bead',
    'beaker',
    'bean',
    'bed',
    'belt',
    'bench',
    'berry',
    'beverage_(drink,_juice,_beer,_beverage,_champagne)',
    'bicycle_(bicycle,_bike)',
    'blanket_(bedsheet,_blanket,_duvet)',
    'blender',
    'block_(material)',
    'blower',
    'bolt_extractor',
    'book_(book,_booklet,_magazine,_manual,_notebook,_novel,_page,_textbook)',
    'bookcase',
    'bottle_(bottle,_flask)',
    'bowl',
    'bracelet_(bangle,_bracelet)',
    'brake_(brake,_break)',
    'brake_pad',
    'branch',
    'bread_(bread,_bun,_chapati,_flatbread,_loaf,_roti,_tortilla)',
    'brick',
    'broccoli',
    'broom_(broom,_broomstick)',
    'brush',
    'bucket',
    'buckle',
    'butter',
    'button',
    'cabbage',
    'cabinet_(cabinet,_compartment,_cupboard)',
    'calculator',
    'caliper',
    'camera',
    'can_opener',
    'canvas',
    'car_(car,_vehicle)',
    'card',
    'cardboard_(cardboard,_paperboard)',
    'carpet',
    'carrot',
    'cart_(cart,_trolley)',
    'cat',
    'ceiling',
    'celery',
    'cello',
    'cement_(cement,_concrete,_mortar)',
    'cereal',
    'chaff',
    'chain',
    'chair',
    'cheese',
    'chicken',
    'chip_(food)',
    "chip_(wood'_metal),",
    'chip_(wood,_metal)',
    'chisel',
    'chocolate',
    'chopping_board',
    'chopstick',
    'cigarette_(cigarette,_vape)',
    'circuit',
    'clamp',
    'clay',
    'clip',
    'clock',
    'cloth_(cloth,_fabric,_garment,_kanga,_rag)',
    'coffee',
    'coffee_machine',
    'colander',
    'comb',
    'computer_(computer,_ipad,_laptop,_motherboard,_screen)',
    'container_(box,_can,_carton,_case,_casing,_container,_crate,_holder,_jar,_jerrycan,_keg,_pack,_package,_packaging,_packet,_storage,_tank,_tin)',
    'cooker',
    'cookie',
    'cork',
    'corn',
    'corner',
    'countertop_(counter,_countertop)',
    'cracker_(biscuit,_cracker)',
    'crayon',
    'cream',
    'crochet',
    'crowbar',
    'cucumber',
    'cup_(cup,_mug,_tumbler)',
    'curtain',
    'cutter_(tool)',
    'decoration_(decoration,_ornament)',
    'derailleur',
    'detergent',
    'dice_(dice,_die)',
    'dishwasher',
    'dog',
    'door',
    'dough',
    'dough_mixer',
    'doughnut',
    'drawer',
    'dress',
    'drill_(drill,_driller)',
    'drill_bit',
    'drum',
    'dumbbell',
    'dust_(dust,_sawdust)',
    'dustpan',
    'egg',
    'engine_(assembly,_carburetor,_engine,_motor)',
    'envelope_(envelop,_envelope)',
    'eraser_(eraser,_rubber)',
    'facemask',
    'fan',
    'faucet_(faucet,_tap)',
    'fence',
    'file_(tool)',
    'filler',
    'filter',
    'fish',
    'fishing_rod',
    'floor_(floor,_ground)',
    'flour',
    'flower',
    'foam',
    'foil',
    'food',
    'foot_(foot,_toe)',
    'fork',
    'fridge_(fridge,_refrigerator)',
    'fries',
    'fuel',
    'funnel',
    'game_controller',
    'garbage_can_(bin,_dustbin)',
    'garlic',
    'gasket',
    'gate',
    'gauge',
    'gauze',
    'gear',
    'generator',
    'ginger',
    'glass',
    'glasses_(goggle,_shade,_spectacle,_sunglass)',
    'glove',
    'glue_(adhesive,_glue,_gum,_sealant)',
    'glue_gun',
    'golf_club',
    'gourd',
    'grain',
    'grapefruit',
    'grass',
    'grater',
    'grill',
    'grinder',
    'guava',
    'guitar',
    'hair',
    'hammer_(hammer,_mallet)',
    'hand_(finger,_hand,_palm,_thumb)',
    'handle',
    'hanger',
    'hat',
    'hay',
    'haystack',
    'head',
    'headphones_(earphone,_headphone)',
    'heater',
    'helmet',
    'hinge',
    'hole',
    'horse',
    'hose',
    'ice',
    'ice_cream',
    'ink',
    'iron',
    'jack_(tool)_(jack,_lift)',
    'jacket_(coat,_jacket)',
    'jug',
    'kale',
    'ketchup',
    'kettle',
    'key',
    'keyboard',
    'knife_(knife,_machete)',
    'label_(label,_tag)',
    'ladder',
    'leaf_(leaf,_leave)',
    'leash',
    'leg_(knee,_leg,_thigh)',
    'lever',
    'lid_(cap,_cover,_lid)',
    'light_(bulb,_flashlight,_lamp,_light)',
    'lighter',
    'lime',
    'lock',
    'lubricant_(grease,_lubricant)',
    'magnet_(magnet,_sphere)',
    'mango',
    'manure_(dung,_manure)',
    'mask',
    'mat_(mat,_rug)',
    'matchstick',
    'meat_(beef,_ham,_meat)',
    'medicine',
    'metal_(lead,_metal,_steel)',
    'microscope',
    'microwave',
    'milk',
    'mirror',
    'mixer',
    'mold_(mold,_molder,_mould)',
    'money_(cash,_coin,_money)',
    'mop',
    'motorcycle_(motorbike,_motorcycle)',
    'mouse_(computer)',
    'mouth',
    'mower_(lawnmower,_mower)',
    'multimeter',
    'mushroom',
    'nail_cutter',
    'nail_gun',
    'nail_polish',
    'napkin_(handkerchief,_napkin,_serviette,_tissue,_wipe)',
    'needle_(hook,_needle)',
    'net',
    'nozzle',
    'nut_(food)',
    'nut_(tool)',
    'oil_(fat,_oil)',
    'okra',
    'onion',
    'oven',
    'paddle',
    'paint',
    'paint_roller',
    'paintbrush',
    'palette',
    'pan_(frypan,_pan,_saucepan)',
    'pancake',
    'panel',
    'pants_(jean,_pant,_short,_trouser)',
    'papaya',
    'paper_(chart,_craft,_newspaper,_note,_paper,_papercraft,_poster,_receipt)',
    'pasta_(noodle,_pasta,_spaghetti)',
    'paste',
    'pastry',
    'pea',
    'peanut',
    'pear',
    'pedal',
    'peel',
    'peeler',
    'peg',
    'pen_(marker,_pen)',
    'pencil',
    'pepper_(vegetable)_(capsicum,_pepper)',
    'phone_(cellphone,_phone,_smartphone)',
    'photo',
    'piano',
    'picture_(picture,_portrait)',
    'pie',
    'pillow',
    'pilot_jet',
    'pin',
    'pipe',
    'pizza',
    'planer_(plane,_planer)',
    'plant_(bud,_frond,_plant,_reed,_seedling,_shrub,_stem,_vine,_weed)',
    'plate_(dish,_plate,_platter,_saucer)',
    'playing_cards',
    'plier',
    'plug',
    'pole',
    'popcorn',
    'pot',
    'pot_(planter)',
    'potato',
    'pump',
    'pumpkin',
    'purse',
    'puzzle_or_game_piece_(chess,_domino,_jenga,_jigsaw,_pawn,_puzzle)',
    'rack',
    'radio',
    'rail_(rail,_railing)',
    'rake',
    'razor_blade',
    'remote_control_(control,_remote)',
    'rice',
    'ring',
    'rod_(dipstick,_rod,_rod_metal,_shaft)',
    'rolling_pin',
    'root',
    'rope',
    'router',
    'rubber_band',
    'ruler_(rule,_ruler)',
    'sand',
    'sander',
    'sandpaper',
    'sauce',
    'sausage',
    'saw_(chainsaw,_saw,_hacksaw)',
    'scarf_(scarf,_shawl)',
    'scissors',
    'scoop_(scoop,_scooper)',
    'scraper_(scraper,_scrapper)',
    'screw_(bolt,_nail,_screw)',
    'screwdriver',
    'sculpture',
    'seasoning_(salt,_seasoning,_shaker,_spice,_sugar)',
    'seed',
    'set_square_(tool)',
    'sewing_machine',
    'sharpener',
    'shears',
    'sheet',
    'shelf',
    'shirt_(cardigan,_shirt,_sweater,_sweatshirt,_top)',
    'shoe_(boot,_sandal,_shoe,_slipper)',
    'shovel_(hoe,_shovel,_spade)',
    'shower_head',
    'sickle',
    'sieve_(sieve,_strainer)',
    'sink_(basin,_sink)',
    'sketch_pad',
    'skirt',
    'slab',
    'snorkel',
    'soap',
    'sock',
    'socket',
    'soil_(dirt,_mud,_soil)',
    'solder_iron',
    'soup',
    'spatula',
    'speaker',
    'sphygmomanometer',
    'spice',
    'spinach',
    'spirit_level',
    'sponge_(scrubber,_sponge)',
    'spoon_(spoon,_spoonful)',
    'spray_(spray,_sprayer)',
    'spring',
    'squeezer',
    'stairs_(stair,_staircase)',
    'stamp',
    'stapler',
    'steamer',
    'steering_wheel',
    'stick_(stick,_twig)',
    'sticker',
    'stock_(food)',
    'stone_(rock,_stone)',
    'stool',
    'stove_(burner,_gas,_stove)',
    'strap',
    'straw',
    'string_(bobbin,_knot,_lace,_ribbon,_spool,_strand,_string,_thread,_twine,_wool,_yarn)',
    'switch_(knob,_switch)',
    'syringe',
    'table_(stand,_table)',
    'tablet',
    'tape_(cellotape,_sellotape,_tape)',
    'tape_measure_(measure,_measurement)',
    'tea',
    'teapot',
    'test_tube',
    'tie',
    'tile',
    'timer',
    'toaster',
    'tomato',
    'tongs',
    'toolbox',
    'toothbrush',
    'toothpick',
    'torch_(torch,_torchlight)',
    'towel',
    'toy_(doll,_toy)',
    'tractor',
    'trash_(debris,_garbage,_litter,_trash,_waste)',
    'tray',
    'treadmill',
    'tree',
    'trimmer_(pruner,_trimmer)',
    'trowel',
    'truck',
    'tweezer',
    'umbrella',
    'undergarment_(boxer,_bra)',
    'vacuum',
    'vacuum_cleaner',
    'valve',
    'vase',
    'video_game',
    'violin',
    'wall',
    'wallet',
    'wallpaper',
    'washing_machine',
    'watch',
    'water',
    'watermelon',
    'weighing_scale',
    'welding_torch',
    'wheat_(maize,_wheat)',
    'wheel_(tyre,_wheel)',
    'whisk',
    'window',
    'windshield',
    'wiper_(car)',
    'wire_(adapter,_cable,_charger,_connector,_cord,_wire)',
    'wood_(fiber,_firewood,_floorboard,_log,_lumber,_plank,_plywood,_timber,_wood,_woodcraft,_woodwork)',
    'worm',
    'wrapper_(covering,_film,_seal,_wrap,_wrapper,_wrapping)',
    'wrench_(spanner,_wrench)',
    'yam',
    'yeast',
    'yoghurt',
    'zipper_(zip,_zipper)',
    'zucchini'
];

export const modality_values = [
    'audio',
    'imu',
    'gaze',
];

export const device_values = [
    'GoPro - Unknown Model',
    'GoPro Hero 4',
    'GoPro Hero Black 7',
    'GoPro Hero Black 8',
    'GoPro Hero Black 9',
    'GoPro Hero Silver 7',
    'GoPro Max',
    'LeaPower',
    'Ordro EP6 4K',
    'Pupil Labs Invisible',
    'Vuzix',
    'Weeview',
    'Zshade',
    'iVue Rincon 1080P',
    'unknown'
];

export const physical_setting_name_values = [
    'Baker',
    'Bike mechanic',
    'Carpenter',
    'Crafter',
    'Scooter mechanic',
    'barbershop',
    'boardgame',
    'card',
    'forest',
    'groupmeeting',
    'gym',
    'home',
    'hotpot',
    'milktea',
    'photo',
    'restaurant',
    'school',
    'tasession',
    'trail'
];

export const dimension_values = [
    '(1088, 1080)',
    '(1280, 720)',
    '(1440, 1080)',
    '(1440, 2880)',
    '(1920, 1080)',
    '(1920, 1440)',
    '(1921, 1080)',
    '(2560, 1440)',
    '(2560, 1920)',
    '(2880, 1080)',
    '(2880, 1440)',
    '(3413, 1920)',
    '(5760, 2880)',
    '(810, 1080)',
    '(None, None)'
];

export const video_source_values = [
    'bristol',
    'cmu',
    'cmu_africa',
    'frl_track_1_public',
    'georgiatech',
    'iiith',
    'indiana',
    'kaust',
    'minnesota',
    'nus',
    'uniandes',
    'unict',
    'utokyo'
];

export const split_values = [
    'av-test',
    'av-train',
    'av-val',
    'fho_hands-test',
    'fho_hands-train',
    'fho_hands-val',
    'fho_lta-test',
    'fho_lta-train',
    'fho_lta-val',
    'fho_oscc-test',
    'fho_oscc-train',
    'fho_oscc-val',
    'fho_scod-train',
    'fho_scod-val',
    'fho_sta-test',
    'fho_sta-train',
    'fho_sta-val',
    'moments-test',
    'moments-train',
    'moments-val',
    'nlq-test',
    'nlq-train',
    'nlq-val',
    'vq-test',
    'vq-train',
    'vq-val',
];

export const benchmark_values = ['av', 'moments', 'vq', 'nlq', 'fho', 'fho_hands', 'fho_lta', 'fho_oscc', 'fho_scod', 'fho_sta'];

export const scenario_values = [
    'ATV scene',
    'Appointments: doctor, dentist',
    'Assembling a puzzle',
    'Assembling furniture',
    'Attending a TA session',
    'Attending a festival or fair',
    'Attending a lecture/class',
    'Attending a party',
    'Attending religious activity',
    'Attending sporting events - watching and participating in',
    "BBQ'ing/picnics",
    'Baker',
    'Baseball',
    'BasketBall',
    'Bike',
    'Bike mechanic',
    'Blacksmith',
    'Bowling',
    'Bus',
    'Camp setup/pack-up/chores',
    'Car - commuting, road trip',
    'Car mechanic',
    'Car/scooter washing',
    'Carpenter',
    'Cleaning / laundry',
    'Cleaning at the gym',
    'Climbing',
    'Clothes, other shopping',
    'Community cleaning',
    'Cooking',
    'Crafting/knitting/sewing/drawing/painting',
    'Crossword puzzle',
    'Cycling / jogging',
    'DEPRECATED : Playing board games',
    'Daily hygiene',
    'Dancing',
    'Doing hair/make-up',
    'Doing yardwork / shoveling snow',
    'Drive-thru food',
    'Drone flying',
    'Eating',
    "Eating at a friend's home",
    'Eating at a restaurant',
    'Eating at the cafeteria',
    'Eating in a canteen',
    'Eating in hawker center',
    'Electronics',
    'Farmer',
    'Fishing',
    'Fixing PC',
    'Fixing musical instrument',
    'Fixing something in the home',
    'Flower Picking',
    'Football',
    'Frisbee',
    'Gaming arcade / pool / billiards',
    'Gardener',
    'Gardening',
    'Getting car fixed',
    'Going to a salon (nail, hair, spa)',
    'Going to the gym - exercise machine, class, weights',
    'Going to the park',
    'Golfing',
    'Grinding mill',
    'Grocery shopping indoors',
    'Hair and Makeup stylist',
    'Handyman',
    'Hanging out at a coffee shop',
    'Hanging out with friends at a bar',
    'Hiking',
    'Hosting a party',
    'Household cleaners',
    'Household management - caring for kids',
    'Indoor Navigation (walking)',
    'Ironing',
    'Jobs Related to Construction',
    'Labwork',
    'Listening to music',
    'Maker Lab',
    'Making Bricks',
    'Making a salad/sandwich',
    'Making coffee',
    'Mehandi',
    'Mini golf',
    'On a screen (phone/laptop)',
    'Outdoor cooking',
    'Outdoor social (includes campfire)',
    'Outdoor technical climbing/belaying/rappelling (includes ropework)',
    'Participating in a meeting',
    'Play with cellphone',
    'Playing Darts',
    'Playing badminton',
    'Playing board games',
    'Playing cards',
    'Playing games / video games',
    'Playing with pets',
    'Potting plants (indoor)',
    'Practicing a musical instrument',
    'Preparing hopot',
    'Pulp Traces Factory (Egges)',
    'Reading books',
    'Reviewing flash cards',
    'Riding motorcycle',
    'Roller skating',
    'Rowing',
    'Scooter mechanic',
    'Skateboard/scooter',
    'Sleeping',
    'Snow sledding',
    'Street art',
    'Swimming in a pool/ocean',
    'Table tennis',
    'Taking photos in photography studio',
    'Talking on the phone',
    'Talking to colleagues',
    'Talking with family members',
    'Talking with friends/housemates',
    'Tourism',
    'Train',
    'Video call',
    'Visiting exhibition',
    'Walking on street',
    'Walking the dog / pet',
    'Washing the dog / pet, grooming horse',
    'Watching movies at the cinema',
    'Watching tv',
    'Working at desk',
    'Working in milktea shop',
    'Working in outdoor store',
    'Working out at home',
    'Working out outside',
    'Writing on whiteboard',
    'Yoga practice',
    'biology experiments',
    'building lego models / plastic models',
    'writing on book'
];

const vq_object_values = [
    "#unsure",
    "5 liter jerry can",
    "ac condenser",
    "ac",
    "access control",
    "accessories rack",
    "acetone bottle",
    "acrylic color tube",
    "acrylic colour",
    "acrylic table stand",
    "action figure",
    "active spray cleanser",
    "adapter",
    "adhesive can",
    "adhesive glue",
    "adhesive gun",
    "adhesive tape",
    "advert bilboard",
    "advert board",
    "advertising floor stand",
    "aerosol can",
    "aerosol spray can",
    "aerosol spray",
    "air blower.",
    "air compressor",
    "air conditioner  control",
    "air conditioner.",
    "air conditioner",
    "air conditioning machine",
    "air cooler switch",
    "air fan",
    "air filter",
    "air freshener",
    "air pump",
    "air regulator",
    "air tool",
    "air",
    "airborne",
    "alarm clock",
    "aluminium ladder",
    "aluminium tray",
    "aluminum bowl with lid",
    "aluminum bowl",
    "aluminum cooking pot",
    "aluminum cup",
    "aluminum foil",
    "aluminum tin",
    "amber bottle",
    "angle broom",
    "angle grinder",
    "ankle boots",
    "anklet",
    "antique",
    "apple desktop",
    "apple tray",
    "apple",
    "apples",
    "aquarium",
    "arbor",
    "ark saw",
    "arm chair",
    "artwork",
    "ash color drill",
    "ashtray",
    "atm machine",
    "atm",
    "awing bag",
    "axe",
    "baby net",
    "baby stroller",
    "baby trolley",
    "baby walker",
    "back pack",
    "back saw",
    "backboard",
    "backet",
    "backpack bag",
    "backpack",
    "backrest pillow",
    "bacon",
    "badge",
    "bag back",
    "bag of cement",
    "bag of fruits",
    "bag pack",
    "bag",
    "bags",
    "bakery bucket",
    "bakery crate",
    "baking bowl",
    "baking pan",
    "baking timer",
    "baking tray",
    "baking weighing scale",
    "ball peen hammer",
    "ball pein hammer",
    "ball point pen",
    "ball",
    "ballon",
    "balloon",
    "ballpoint pen",
    "balls",
    "baloon",
    "banana fibre",
    "banana",
    "bananas",
    "bandage",
    "bangle",
    "barbecue stand",
    "barcode reader",
    "barcode roll",
    "barcode scanner",
    "base ball cap",
    "base",
    "baseball base",
    "baseball bat",
    "baseball cap",
    "baseball glove",
    "baseball",
    "basin",
    "basket laundry",
    "basket trolley",
    "basket",
    "basketball board",
    "basketball hoop",
    "basketball net",
    "basketball post",
    "basketball ring",
    "basketball",
    "basketballs",
    "baskets",
    "bat",
    "bath mat",
    "bathroom mat",
    "batter plate",
    "batteries",
    "battery clamp",
    "battery clip",
    "battery jump starter",
    "battery",
    "beam balance",
    "beanie	cap",
    "beanie hat",
    "becket",
    "bed pillows",
    "bed side lamp",
    "bed",
    "bedcover",
    "bedlamp",
    "bedside drawer",
    "bedside lamp",
    "beef",
    "beer cans",
    "beer_can",
    "bell",
    "belleville washer",
    "belt buckle",
    "belt",
    "bench chair",
    "bench scrapper",
    "bench vice",
    "bench",
    "benches",
    "beret cap hat",
    "beret cap",
    "beret hat",
    "beret knit hat",
    "beret",
    "bicycle air pump",
    "bicycle parts",
    "bicycle rim",
    "bicycle saddle",
    "bicycle seat",
    "bicycle tire",
    "bicycle tires",
    "bicycle tube",
    "bicycle wheel",
    "bicycle.",
    "bicycle",
    "bicycles",
    "bike chain",
    "bike helmet",
    "bike peddle",
    "bike seat cover",
    "bike tire",
    "billhook knife",
    "billing machine",
    "bin bag",
    "bin basket",
    "bin",
    "binding wire",
    "bins",
    "birthday cape",
    "biscuit pack",
    "biscuit",
    "biscuits",
    "black  cloths crate",
    "black & white scarf",
    "black and brown belt",
    "black bag",
    "black basket",
    "black belt",
    "black bin",
    "black boots",
    "black bottle",
    "black bowl",
    "black box",
    "black bucket",
    "black clutch bag",
    "black container",
    "black cooler",
    "black doormat",
    "black dustbin",
    "black flip flop",
    "black flower pot",
    "black glove",
    "black jacket",
    "black jug",
    "black knife",
    "black mug",
    "black oil container",
    "black pickup",
    "black purse",
    "black round leather pouf",
    "black sellotape",
    "black slipper",
    "black slippers",
    "black storage container",
    "black suitcase",
    "black t shirt",
    "black tape",
    "black tool box",
    "black trash bin",
    "black watch",
    "black watering can",
    "black wheelbarrow",
    "blade cutter",
    "blade",
    "blanket",
    "blause",
    "blender cup",
    "blender jar",
    "blender",
    "block hammer",
    "block",
    "blouse",
    "blow dry",
    "blower",
    "blowtorch",
    "blue backpack",
    "blue ball point pen",
    "blue bin",
    "blue bottle",
    "blue bucket",
    "blue cap",
    "blue checked scarf",
    "blue clothe",
    "blue container",
    "blue dress",
    "blue drum",
    "blue dustbin",
    "blue flask",
    "blue foam",
    "blue hat",
    "blue helmet",
    "blue jerry can",
    "blue jerrycan",
    "blue knife",
    "blue mug",
    "blue napkin",
    "blue paper",
    "blue pen",
    "blue plier",
    "blue rag",
    "blue scarf",
    "blue scraper",
    "blue shopping basket",
    "blue shovel",
    "blue sneakers",
    "blue spray bottle",
    "blue table",
    "blue tie",
    "blue tool box",
    "blue tooth speaker",
    "blue towel",
    "blue trash bin",
    "blue waste bin",
    "bluetooth speaker",
    "bluetooth",
    "board",
    "boat paddle",
    "bob",
    "boboli crust",
    "body balance ball",
    "bolt cutter",
    "bolt",
    "bone",
    "bonnet",
    "book cabinet",
    "book shelf",
    "book stand",
    "book.",
    "book",
    "bookcase",
    "booklet",
    "books",
    "boot shoe",
    "boot shoes",
    "boot",
    "boots",
    "bottle brush--",
    "bottle brush",
    "bottle cap",
    "bottle jack",
    "bottle lid",
    "bottle of beer",
    "bottle of detergent",
    "bottle of drink",
    "bottle of engine oil",
    "bottle of juice",
    "bottle of liquid",
    "bottle of oil",
    "bottle of olive oil",
    "bottle of pills",
    "bottle of sanitizer",
    "bottle of soap",
    "bottle of vinegar",
    "bottle of water",
    "bottle of whiskey",
    "bottle of wish bone",
    "bottle opener",
    "bottle six pack",
    "bottle soap",
    "bottle spray",
    "bottle sprayer",
    "bottle top",
    "bottle water",
    "bottle.",
    "bottle",
    "bottled water pack",
    "bottled water",
    "bottles",
    "bowdl",
    "bowl of fruits",
    "bowl plate",
    "bowl strainer",
    "bowl with brush",
    "bowl.",
    "bowl",
    "box grater",
    "box of gloves",
    "box of handkerchief",
    "box of ties",
    "box of wood",
    "box pack",
    "box packet",
    "box.",
    "box",
    "boxes",
    "bracelet",
    "bracelets",
    "brake disk",
    "brake fluid",
    "brake pad",
    "brake rotor",
    "brake shoe",
    "brake spring pliers",
    "branch",
    "branded paper bag",
    "bread loaves",
    "bread toaster",
    "bread",
    "breadmaker",
    "brick",
    "bringals",
    "bristle brush",
    "broom and dustpan",
    "broom brush",
    "broom",
    "brown bag",
    "brown boot",
    "brown boots",
    "brown box",
    "brown brush",
    "brown cap",
    "brown chopping board",
    "brown cup",
    "brown dough",
    "brown gloves",
    "brown harness",
    "brown napkin",
    "brown paper bag",
    "brown paper",
    "brown piece of cloth",
    "brown scraper",
    "brown shoes",
    "brown tablemat",
    "brown throw pillow",
    "brown tumbler",
    "brush and dustpan set",
    "brush broom",
    "brush head",
    "brush holder",
    "brush scrubber",
    "brush",
    "bt speaker",
    "bucket cover",
    "bucket shelf",
    "bucket.",
    "bucket",
    "bucket`",
    "buckets",
    "building",
    "bulb box",
    "bulb holder",
    "bulb protector cage",
    "bulb",
    "bunch of bananas",
    "bunch of keys",
    "bunch of spinach",
    "burete cap",
    "bush",
    "busket tray",
    "busket",
    "butcher knife",
    "butter knife",
    "butter",
    "bypass shear",
    "cabbage",
    "cable reel",
    "cable wire",
    "cable",
    "cage-",
    "cage",
    "cake box",
    "cake",
    "calculator",
    "calendar",
    "calibrated bottle",
    "caliper",
    "calipers",
    "calliper",
    "camber",
    "camera",
    "camp gas",
    "camp tent",
    "camping chair",
    "camping tent",
    "can container",
    "can lid",
    "can of soda",
    "can spray",
    "can",
    "candle lamp",
    "candle vase",
    "candle",
    "candy",
    "canister",
    "canned drink",
    "cannon",
    "canvas art",
    "cap",
    "car battery",
    "car bettery",
    "car jack",
    "car key",
    "car oil change tank",
    "car rim",
    "car seat",
    "car shock",
    "car spray",
    "car tire",
    "car toy",
    "car tyre",
    "car wheel",
    "car",
    "carburetor",
    "card game",
    "card reader",
    "card",
    "cardboard box",
    "cardboard paper",
    "cardboard",
    "cards",
    "carpenter level",
    "carpenter measuring tape",
    "carpenter ruler",
    "carpenter triangle ruler",
    "carpentry ruler",
    "carpet rug",
    "carrier bag",
    "carrot",
    "carrots",
    "cart",
    "carton box",
    "carton",
    "cartoon box",
    "carved wood",
    "case",
    "cash counter machine",
    "cash counting machine",
    "cash register machine",
    "cash register",
    "cashier machine",
    "castrol engine oil drum",
    "cat bed",
    "cat bowl",
    "cat house",
    "cat plate",
    "cat toy",
    "cat",
    "catalyst bottle",
    "catapult",
    "catton box",
    "caulk gun",
    "caution sign",
    "cctv camera",
    "cd",
    "ceiling light",
    "cell phone",
    "cell tape",
    "cello tape dispenser",
    "cello tape",
    "cellophane tape",
    "cellotape",
    "cellphone",
    "cement bucket",
    "centerpoint tape measure",
    "central processing unit.",
    "centrifuge machine",
    "ceramic bowl",
    "ceramic glass",
    "ceramic jar",
    "ceramic pineapple",
    "ceramic plate",
    "ceramic pot",
    "ceramic",
    "cereal bag",
    "cereal bowl",
    "cerial",
    "chaff cutter",
    "chain saw",
    "chair stool",
    "chair.",
    "chair",
    "chameleon",
    "chandelier",
    "chapati pan",
    "charger head",
    "charger",
    "chat",
    "chees",
    "cheese",
    "chef knife",
    "chemical jerrycan",
    "chest box",
    "chicken broth box",
    "children desk",
    "chili pepper",
    "chimney",
    "chinese cleaver",
    "chinese knife",
    "chip card reader",
    "chisel draft",
    "chisel",
    "chocolate bar container",
    "chocolate cover",
    "chocolate",
    "chop board",
    "chop sticks",
    "chopping board",
    "chopping stick",
    "chopping sticks",
    "chopstick",
    "chopsticks",
    "churnbrush",
    "cigarette pack",
    "circle metal bar",
    "circular saw",
    "circus",
    "clamp",
    "clamps",
    "claw bar",
    "claw hammer",
    "clay pot",
    "cleaning bottle spray",
    "cleaning cloth",
    "cleaning detergent",
    "cleaning fluid",
    "cleaning hand wiper",
    "cleaning rug",
    "cleaning soap's tin",
    "cleaning sponge",
    "cleaning sponger",
    "cleaning wipes",
    "clear polythene roll",
    "clever",
    "climbing harness",
    "cling film",
    "cling wrap",
    "clip cutter",
    "clip lock container",
    "clip",
    "clips",
    "clock.",
    "clock",
    "clorox",
    "cloth banner",
    "cloth hanger",
    "cloth material",
    "cloth rack",
    "cloth rag",
    "cloth----------------------",
    "cloth.",
    "cloth",
    "clothe material",
    "clothe",
    "clothes",
    "coat hanger",
    "coat",
    "coconut fruit",
    "coconut leaf sheaths",
    "coconut shell",
    "coconut tree",
    "coconut",
    "coffee carafe",
    "coffee cup",
    "coffee machine",
    "coffee maker machine",
    "coffee maker",
    "coffee marker",
    "coffee mate",
    "coffee mixer",
    "coffee mug",
    "coffee table",
    "coil spring",
    "coil",
    "coking pan",
    "colander bowl",
    "colander",
    "colgate toothpaste box",
    "colourless vase",
    "combination spanner",
    "combine spanner",
    "compact router",
    "computer keyboard",
    "computer monitor",
    "computer mouse",
    "computer",
    "concrete plate",
    "concrete trowel",
    "condenser",
    "condiment",
    "cone shaped bowl",
    "connect 4 game",
    "connect 4 yellow chips",
    "console pad",
    "console",
    "construction glasses",
    "construction lamp",
    "contact adhesive gun",
    "container lid",
    "container paint",
    "container spray",
    "container's lid",
    "container",
    "container==",
    "cooker lighter",
    "cooker",
    "cookies",
    "cooking container",
    "cooking ethanol",
    "cooking gas grill",
    "cooking lid",
    "cooking lighter",
    "cooking mitt",
    "cooking oil bottle",
    "cooking oil",
    "cooking pan.",
    "cooking pan",
    "cooking play pan",
    "cooking pot lid",
    "cooking pot.",
    "cooking pot",
    "cooking spoon",
    "cooking stick",
    "cookong pot",
    "cooler box",
    "cooler switch",
    "cooler----------------------------------",
    "cooler",
    "coping saw",
    "cord",
    "corded power sander",
    "cordless drill driver",
    "cordless drill machine",
    "cordless drill",
    "cordless driver",
    "cordless electric screwdriver",
    "cordless ratchet",
    "cordless screw gun",
    "cordless screwdriver",
    "cork",
    "corn pop",
    "corn starch",
    "corn",
    "cotton bud",
    "couch",
    "counter billing machine",
    "cow",
    "cpu",
    "crate of drinks",
    "crate of eggs",
    "crate",
    "cream kitchen towel",
    "cream paper bag",
    "cream",
    "credit card",
    "creeper seat",
    "cricket ball",
    "cricket bat",
    "crochet hat",
    "crocs",
    "crop bin",
    "crop mug",
    "crop vase",
    "crop wood",
    "crop",
    "cross bag",
    "crotchet hat",
    "crow bar",
    "crowbar",
    "cucumber",
    "cup holder",
    "cup of water",
    "cup",
    "cupboard",
    "cupcake cup",
    "cupcake liners",
    "cups",
    "curtain sheers",
    "curtain",
    "cushion",
    "cut knife",
    "cuter",
    "cutlass",
    "cutlery basket",
    "cutlery holder",
    "cutter knife",
    "cutter pliers",
    "cutter",
    "cutting board",
    "cutting disk",
    "cutting dough",
    "cutting machine",
    "cutting mat",
    "cutting pliers",
    "cutting scissors",
    "cuv car",
    "cylinder",
    "cylindrical jar",
    "dagger",
    "dartboard backer",
    "deco pot",
    "decoder",
    "decor",
    "décor",
    "decorating item",
    "decoration ball",
    "decoration",
    "decorations",
    "decorative flower",
    "decorative item",
    "decorative jar",
    "decorative",
    "deep fryer",
    "deep frying pan",
    "deep frying pot",
    "deflated ball",
    "deodorant  bottle",
    "deodorant",
    "desk fan",
    "desk lamp",
    "desk name tag",
    "desk top",
    "desk",
    "desktop computer",
    "desktop globe",
    "desktop monitor",
    "desktop",
    "detergent bottle",
    "detergent can",
    "detergent container",
    "detergent soap",
    "detergent",
    "dettol bottle",
    "dewalt tool",
    "diary",
    "diesel bottle",
    "dietary supplement",
    "digital meter",
    "digital switch",
    "digital timer",
    "digital weighing scale",
    "dinning chair",
    "disc plate",
    "disc plow",
    "dish brush",
    "dish cloth",
    "dish of biscuit",
    "dish rack",
    "dish soap bottle",
    "dish soap",
    "dish sponge",
    "dish washer",
    "dish washing sponge",
    "dish",
    "dishes",
    "dishware",
    "dishwasher",
    "dishwashing liquid",
    "dishwashing steel wool",
    "disinfectant wipes",
    "disinfectant",
    "disinfecting wipes container",
    "disk",
    "dispenser water bottle",
    "dispenser",
    "dispensing bottle",
    "display cabinet",
    "display chiller",
    "display freezer",
    "display stand",
    "disposable coffee-cup",
    "disposable cup",
    "disposable cups",
    "disposable forks",
    "disposable plate",
    "disposal cup",
    "dog bed",
    "dog bowl",
    "dog chew toy",
    "dog leash",
    "dog nest bed",
    "dog plate",
    "dog rope",
    "dog sign",
    "dog strap",
    "dog toy",
    "dog.",
    "dog",
    "dogs reflector",
    "doll",
    "donuts",
    "door alarm",
    "door handle",
    "door knob",
    "door lock",
    "door mat",
    "door",
    "doorbell",
    "doormat",
    "dotting brush",
    "double cat bowl",
    "double end ring spanner",
    "dough bench scraper",
    "dough bowl",
    "dough cutter",
    "dough mixer",
    "dough press",
    "dough rolls board",
    "dough scoop",
    "dough scraper",
    "dough scrapper",
    "dough tray",
    "dough",
    "drainer",
    "drawer filing cabinet",
    "drawer",
    "drawing palette",
    "drawing pen",
    "drawing",
    "drawstring backpack",
    "dressing mirror",
    "drill bit",
    "drill driver",
    "drill gun",
    "drill machine",
    "drill",
    "driller machine",
    "driller",
    "drilling machine",
    "drilling wrench",
    "drink can",
    "drink cane",
    "drink cans",
    "drip pipe",
    "driveway lights.",
    "drug container",
    "drug",
    "drum bells",
    "drum container",
    "drum set",
    "drum stick",
    "drum sticks",
    "drum",
    "drumstick",
    "drumsticks",
    "dry leaf sheaths",
    "dry leaves",
    "dual shock playstation",
    "dual shock",
    "duct tape",
    "dumb bell",
    "dumbbell",
    "dumbbells",
    "dumbell",
    "dummy",
    "dumpster",
    "dust basket",
    "dust bin",
    "dust bin`",
    "dust coat",
    "dust mask",
    "dust mop",
    "dust pan and brush",
    "dust pan",
    "dustbin bag",
    "dustbin bucket",
    "dustbin.",
    "dustbin",
    "dustpan",
    "duvet covers",
    "duvet",
    "ear dirt remover",
    "ear muff",
    "ear muffs",
    "earmuff",
    "earmuffs",
    "earphone",
    "earphones",
    "earthen pot",
    "earthgro",
    "eating sticks",
    "egg carton",
    "egg shell",
    "egg tray",
    "egg",
    "eggplant",
    "eggs tray",
    "eggs",
    "electric  wrench",
    "electric bolts tighten machine",
    "electric cable",
    "electric cooking pot",
    "electric curve saw",
    "electric cutter",
    "electric drill",
    "electric drilling machine",
    "electric exit",
    "electric fan",
    "electric hotpot",
    "electric iron",
    "electric jug",
    "electric kettle heating base",
    "electric kettle.",
    "electric kettle",
    "electric machine",
    "electric mug",
    "electric planer",
    "electric pot",
    "electric reciprocating saw",
    "electric sack truck",
    "electric sander",
    "electric screw driver",
    "electric screwdriver",
    "electric serving pot",
    "electric switch",
    "electric water pump machine",
    "electric weighing scale",
    "electric wire",
    "electrical bolt tightening machine",
    "electrical contact cleaner lubricant",
    "electrical water pump",
    "electronic beam balance",
    "electronic machine",
    "electronic",
    "eletric jug",
    "eletric kettle",
    "empty cloth crates",
    "energy drink can",
    "energy drink",
    "engine cover",
    "engine oil  bottle",
    "engine oil bottle",
    "engine oil",
    "engine",
    "envelop",
    "envelope",
    "exercise ball",
    "exercise bench",
    "exercise book",
    "exercise mat",
    "exhaust pipe",
    "exhaust",
    "exhauster pipe",
    "extension box",
    "extension socket",
    "extension",
    "extinguisher",
    "eye glass",
    "eye glasses",
    "eyeglass case",
    "eyeglass",
    "eyeglasses",
    "f-clamp",
    "fabric softener",
    "fabric",
    "face cap",
    "face mask",
    "face shield",
    "facemask",
    "facial tissue",
    "fan blade guard",
    "fan blade",
    "fan",
    "faucet",
    "feeding chair",
    "fertilizer",
    "file organizer rack",
    "file",
    "filing machine",
    "fir extinguisher",
    "fire extinguisher",
    "fire hydrant",
    "fire-extinguisher",
    "firewood",
    "first aid box",
    "first aid kit",
    "fitness mat",
    "flag",
    "flashdisk",
    "flashlight",
    "flask lid",
    "flask mug",
    "flask",
    "flat file",
    "flat frying pan",
    "flat pan",
    "flat screen",
    "flat washer",
    "flat-head screwdriver-",
    "flathead screwdriver",
    "fleece towel",
    "flip flop",
    "flip flops",
    "float",
    "floater",
    "floating tube",
    "flood light",
    "floor advertising stand",
    "floor brush",
    "floor cleaning mop",
    "floor fan",
    "floor lamp",
    "floor machine cleaner",
    "floor mat",
    "floor mirror",
    "floor mop",
    "floor poster stand",
    "floor pump",
    "floor scraper",
    "floor scrubber brush",
    "floor scrubbing brush",
    "floor wiper",
    "floormat",
    "flop slippers",
    "flour bucket",
    "flour container",
    "flour mixer machine",
    "flour mixer",
    "flour mixture bowl",
    "flour sac",
    "flour scoop",
    "flour tray",
    "flour",
    "flourescent lamp",
    "flower  bucket",
    "flower  vase",
    "flower and vase",
    "flower basket",
    "flower bucket",
    "flower plant",
    "flower pot",
    "flower stand",
    "flower vase rack",
    "flower vase",
    "flower vessel",
    "flower",
    "flowerpot",
    "flowers",
    "fluffy toy",
    "fluorescent tube",
    "flyer",
    "flying tiger fresh mint",
    "foam",
    "foil paper",
    "foil",
    "fold chair",
    "foldable chair",
    "foldable laundry bag",
    "foldable measuring stick",
    "folder",
    "folding chair",
    "folding ruler",
    "folding step ladder",
    "folgers coffee container",
    "folgers coffee containers",
    "folgers",
    "food  basket",
    "food banner",
    "food container",
    "food cooler",
    "food pack",
    "food storage container",
    "food warmer.",
    "food warmer",
    "food wrap",
    "food",
    "foot  mat",
    "foot mat",
    "foot stool",
    "football",
    "footmat",
    "footwear",
    "fork spanner",
    "fork spoon",
    "fork",
    "frame",
    "freezer board",
    "freezer",
    "freshener",
    "fridge magnet",
    "fridge tray",
    "fridge.",
    "fridge",
    "fruit bowl",
    "fruits",
    "fry pan",
    "frying pan",
    "fuel bottle",
    "fuel can",
    "fuel container",
    "fun",
    "funnel",
    "fur coat",
    "g-clamp",
    "gadget",
    "gallon drum",
    "gallon water jug",
    "gallon",
    "game console",
    "game controller",
    "game disk",
    "game pad controller",
    "game pad",
    "game pads",
    "gamepad",
    "gaming mouse",
    "gaming pad",
    "garage spray",
    "garbage bag",
    "garbage bin",
    "garden bench",
    "garden broom",
    "garden gate",
    "garden hoe",
    "garden hose faucet switch",
    "garden incenerator bin",
    "garden light",
    "garden scissor",
    "garden shear",
    "garden trowel",
    "gardening shears",
    "gardening spray bottles",
    "garlic cloves",
    "garlic",
    "garment",
    "gas can",
    "gas cooker",
    "gas cylinder",
    "gas grill",
    "gas lighter",
    "gas stove",
    "gate",
    "gear",
    "gearshift",
    "generator",
    "gift box",
    "gillette",
    "gin bottle",
    "glass bin",
    "glass bottle",
    "glass bowl",
    "glass case",
    "glass cleaner",
    "glass container",
    "glass cup",
    "glass dish",
    "glass fridge shelf",
    "glass jar",
    "glass of wine",
    "glass tumbler",
    "glass water",
    "glass",
    "glasses box",
    "glasses",
    "global map stand ball",
    "global table ball map",
    "globe clipart",
    "globe map ball",
    "globe",
    "glove box",
    "glove",
    "gloves.",
    "gloves",
    "glue bottle",
    "glue bucket",
    "glue gun",
    "glue stick",
    "glue tin",
    "glue tube",
    "glue",
    "gmy ball",
    "goal post",
    "gold nozzle bit",
    "golden sacks",
    "golf bag",
    "golf ball",
    "golf cart bag",
    "golf cart screen",
    "golf club",
    "golf flag",
    "golf stick",
    "golf trolley",
    "golf",
    "googles",
    "grain can",
    "grain packet",
    "grain scooper",
    "grapes",
    "grass blower",
    "grass cutter",
    "grass edger",
    "grass trimmer",
    "grater",
    "grease bottle",
    "grease can",
    "grease container",
    "grease lubricant",
    "grease",
    "greasing oil",
    "green apples",
    "green back pack",
    "green bag",
    "green basket",
    "green baskets",
    "green bottle",
    "green bowl",
    "green box",
    "green bucket",
    "green cello tape",
    "green chain",
    "green container",
    "green cup",
    "green drum",
    "green dustbin",
    "green frame",
    "green hat",
    "green hose",
    "green impact driver",
    "green impact wrench",
    "green knife",
    "green lawn mower",
    "green lawnmower",
    "green packaging box",
    "green pepper",
    "green pipe",
    "green plastic bottle",
    "green plastic container",
    "green plate",
    "green power drill",
    "green power wrench",
    "green recycle bin",
    "green rope",
    "green sellotape",
    "green serving spoon",
    "green skirt",
    "green sneakers",
    "green tin",
    "green water bottle.",
    "greese oil",
    "grey backdrop",
    "grey bag",
    "grey bucket",
    "grey car",
    "grey chair",
    "grey clothe",
    "grey pair of hiking boots",
    "grill pan",
    "grill",
    "grinder",
    "grinding machine",
    "grocery bag",
    "guitar",
    "gumboots",
    "gym bag",
    "gym ball",
    "gym bench",
    "gym mat",
    "hack saw",
    "hacksaw",
    "hair iron",
    "hairband",
    "half concrete block",
    "hammer drill",
    "hammer",
    "hand axe",
    "hand bag",
    "hand broom",
    "hand brush",
    "hand cloth",
    "hand clothe",
    "hand clutch",
    "hand cream",
    "hand cutter",
    "hand drill tool",
    "hand drill.",
    "hand drill",
    "hand file",
    "hand glove",
    "hand gloves",
    "hand hoe",
    "hand knife",
    "hand mixer",
    "hand plane",
    "hand porch",
    "hand pouch",
    "hand sander",
    "hand sanitiser",
    "hand sanitizer",
    "hand saviet",
    "hand saw",
    "hand shopping cart",
    "hand sprayer pump",
    "hand towel",
    "hand trowel",
    "hand wallet",
    "hand wash soap",
    "hand wash",
    "hand weeder",
    "handbag",
    "handheld power tool",
    "handkerchief",
    "handle broom",
    "handle brush",
    "handle cover",
    "handle dustpan",
    "handmade dumbbell",
    "hands dril",
    "handsaw",
    "handset",
    "handtowel",
    "hanger",
    "hangers",
    "hat",
    "head cap",
    "head phones",
    "head scarf",
    "head warmer",
    "headphone",
    "headphones",
    "headset",
    "heater",
    "hedge shear",
    "hedge shears",
    "heel shoe",
    "heel shoes",
    "heels",
    "helment",
    "helmet",
    "hemate",
    "hex bolt",
    "hex key",
    "high black leather stool",
    "hockey ball",
    "hoe",
    "holder",
    "hole digger",
    "home décor vessel",
    "home phone",
    "honey bottle",
    "honey jar",
    "honey",
    "hoodie",
    "hook set",
    "horse pipe",
    "hose pipe",
    "hose",
    "hot pot",
    "hot source",
    "hotpot",
    "hourglass shaped sauce bottle",
    "house palnt",
    "house plant",
    "house",
    "houseplant",
    "hub",
    "hummer",
    "hydraulic jack",
    "ice box",
    "ice bucket",
    "ice candy",
    "ice cooler box",
    "ice cream",
    "ice scoop",
    "iguana",
    "impact drill",
    "impact driver",
    "impact screwdriver bit",
    "impact wrench",
    "impact wretch machine",
    "indoor plant",
    "ink can",
    "insecticide",
    "instant pot",
    "instruction paper",
    "intercom",
    "ipad phone",
    "ipad",
    "iron board",
    "iron box",
    "iron sheet",
    "iron sponge",
    "iron",
    "ironing table",
    "items list",
    "jack",
    "jacket",
    "jacuzzi",
    "jam can",
    "jar mug",
    "jar of mayonnaise",
    "jar",
    "jbl bluthooth speaker",
    "jean",
    "jeans pans",
    "jellies sandal shoes",
    "jembe",
    "jenga block",
    "jenga box",
    "jenga game",
    "jerican",
    "jerk",
    "jerrican",
    "jerry can lid",
    "jerry can",
    "jerrycan",
    "jigsaw",
    "joint filler",
    "joint splitter",
    "joystick",
    "jug",
    "jugs",
    "juice bottle",
    "juice carton",
    "juice packet",
    "juice",
    "juicer",
    "jumper",
    "kale",
    "kanga",
    "karni tool",
    "kayak boat stand",
    "keg",
    "kettle grill",
    "kettle heater",
    "kettle jug",
    "kettle",
    "key clip",
    "key",
    "keyboard",
    "keyholder",
    "keys",
    "khaki bag",
    "kick stool",
    "kidney beans pack",
    "kids chair",
    "kids pillow",
    "kitchen appliance",
    "kitchen brush",
    "kitchen cloth",
    "kitchen glove",
    "kitchen gloves",
    "kitchen knife",
    "kitchen mat",
    "kitchen mitt",
    "kitchen mitten",
    "kitchen mittens",
    "kitchen napkin",
    "kitchen oven",
    "kitchen paper roll",
    "kitchen paper",
    "kitchen plastic basket",
    "kitchen rack",
    "kitchen roll",
    "kitchen rolls",
    "kitchen scale",
    "kitchen serviette",
    "kitchen sink",
    "kitchen socket",
    "kitchen sponge",
    "kitchen tissue roll",
    "kitchen tissue",
    "kitchen tissues",
    "kitchen towel roll",
    "kitchen towel",
    "kitchen weighing machine",
    "kitchen weighing scale",
    "knack techno pack",
    "knee pad",
    "knife holder",
    "knife sheath",
    "knife.",
    "knife",
    "knit hat",
    "knitted beret",
    "knitted hat",
    "knitting string",
    "kurta tunic",
    "l square ruler",
    "l-spanner",
    "l-type spanner",
    "l-wrench",
    "lab coat",
    "lab glass",
    "lab jug",
    "laboratory coat",
    "ladder",
    "ladle",
    "lady wallet",
    "lamp light",
    "lamp shade",
    "lamp stand",
    "lamp",
    "lamps",
    "lampshade",
    "lampstand",
    "landline phone",
    "landline",
    "lang handle broom",
    "lantern",
    "lap top",
    "laptop.",
    "laptop",
    "large bottled water",
    "large spoon ladle",
    "laser level machine",
    "laundry bag",
    "laundry basket",
    "laundry detergent",
    "laundry plastic",
    "lawn mower",
    "lawn tractor",
    "lawn",
    "lawnmower",
    "lay's snack",
    "layout  tool",
    "lays kettle snack",
    "lead acid battery",
    "leaf blower",
    "leaf sheaths",
    "leash handle",
    "leash",
    "leather bag",
    "leather belt",
    "leather jacket",
    "leave",
    "left hand glove",
    "lemon",
    "lettuce",
    "lid",
    "lifebuoy ring",
    "light blue plastic container",
    "light cover",
    "light switch",
    "light",
    "lighter",
    "lightning connector",
    "linen towel",
    "lipstick",
    "liquid bottle",
    "liquid detergent bottle",
    "liquid dishwashing soap",
    "liquid oil",
    "liquid seal",
    "liquid shop",
    "liquid soap bottle",
    "liquid soap",
    "liquid wash",
    "liquor bottle",
    "litte bin",
    "litter b in",
    "litter bin",
    "litter tray",
    "litterbin",
    "loaded shopping basket",
    "loaf of bread",
    "lock nut spanner",
    "locker",
    "locking grip plier",
    "locking wrench",
    "loctite pl",
    "long chisel bar",
    "long handle dust pan with brush",
    "long nose pliers",
    "long sleeved t-shirt",
    "longboard sander",
    "looping shears",
    "loppers",
    "lopping shears",
    "lotion bottle",
    "lotion",
    "lubricant bottle",
    "lubricant can",
    "lubricant oil",
    "lubricant spray  wd 40",
    "lubricant spray bottle",
    "lubricant spray wd  40",
    "lubricant",
    "luggage bag",
    "luggage",
    "lumber",
    "lunch bag",
    "lunch box",
    "lunch dish",
    "lunchbox",
    "machet",
    "machete",
    "machette",
    "machine gun",
    "machine",
    "magazine rack",
    "magazine",
    "magnetic tray",
    "mail box",
    "mailbox",
    "maize scooper",
    "maker pen",
    "makeup bag",
    "malgia polvere spray",
    "mallet",
    "mango tray",
    "manilla roll",
    "mannequin",
    "mantle clock",
    "manual paper",
    "manual",
    "manure",
    "mark pen.",
    "mark pen",
    "marker pen",
    "marker",
    "maroon beanie hat",
    "maroon pillow",
    "marvin hat",
    "marvin",
    "mask tape",
    "mask",
    "masking tape",
    "mat",
    "match box",
    "matchbox",
    "mavin cap",
    "mayonnaise",
    "mayonnesse",
    "measurement scale",
    "measuring bottle",
    "measuring cup",
    "measuring jar",
    "measuring jug",
    "measuring mass",
    "measuring scale",
    "measuring scoop",
    "measuring spoon",
    "measuring spoons",
    "measuring tape",
    "measuring triangle ruler",
    "meat slicer",
    "mechanic mat",
    "mechanical trolley seat",
    "medal",
    "medical kit",
    "medical tray cart",
    "medicine ball",
    "medicine kit",
    "melon fruit",
    "memory card",
    "menu",
    "mesh bin",
    "mesh strainer bowl",
    "metal bar",
    "metal basin",
    "metal big tin",
    "metal bowl",
    "metal brush scrubber",
    "metal can",
    "metal chair",
    "metal clip",
    "metal cup",
    "metal elastic rod",
    "metal frame",
    "metal glass",
    "metal grinder",
    "metal pipe",
    "metal plate",
    "metal rod",
    "metal rods",
    "metal ruler",
    "metal stool",
    "metal tin",
    "metal tool storage",
    "metal wire sponge",
    "metal",
    "metallic bin",
    "metallic board",
    "metallic bowl",
    "metallic cup",
    "metallic tool",
    "metallic tray",
    "meter box",
    "meter",
    "metric tape measure",
    "micowev",
    "micro atm",
    "micro atms",
    "micro pipette",
    "micro wave",
    "microfiber towel",
    "micropipette",
    "microscope",
    "microwave",
    "milk bottle",
    "milk can",
    "milk packet",
    "milk packets",
    "milk",
    "minced meat",
    "mini displayport to hdmi adapter",
    "mini hand fan",
    "mini ladder",
    "mini suv",
    "mini-fan",
    "mint tin",
    "mirror",
    "miter saw",
    "mitt",
    "mitten glove",
    "mitten",
    "mixer",
    "mixing bowl",
    "mixing cup",
    "mixing spoon",
    "mobile phone",
    "mobile tablet",
    "mobile",
    "moka pot",
    "money machine",
    "monitor",
    "mop bucket & wringer",
    "mop bucket",
    "mop stick",
    "mop",
    "moping bucket",
    "mortar",
    "mother's",
    "motor cycle",
    "motor oil bottle",
    "motor oil container",
    "motorbike",
    "motorcycle brake pad packet",
    "motorcycle rim",
    "motorcycle",
    "mouse pad",
    "mouse",
    "movie disk",
    "mower blade",
    "mowing machine",
    "mr krips",
    "mug cup",
    "mug",
    "multimeter",
    "music keyboard",
    "nail container",
    "nail file",
    "nail gun-",
    "nail gun",
    "nail polish",
    "nail puller",
    "nail",
    "nails storage container",
    "nails tin",
    "napkin dispenser",
    "napkin",
    "navy blue jacket",
    "neck scarf",
    "neck tie",
    "neckless",
    "necktie",
    "needle machine.",
    "needle",
    "net bag",
    "net plastic basin",
    "net",
    "news paper",
    "newspaper",
    "night lamp",
    "night stand",
    "nightstand",
    "nipper",
    "non stick cooking pot",
    "nose mask",
    "nose pliers",
    "notch trowel",
    "note book",
    "note pad",
    "notebook",
    "notepad",
    "notice stand",
    "notice",
    "novel book",
    "novel",
    "nozzle cleaner set",
    "nursery",
    "nut bottle",
    "nut cracker",
    "nut driver",
    "nut gun",
    "nut",
    "nuts & bolts tin",
    "nutter butter box",
    "nylon pack",
    "nylon paper",
    "nylon roll",
    "nylon",
    "oar",
    "oats & more",
    "office chair",
    "office desk telephone",
    "office seat",
    "oil bottle.",
    "oil bottle",
    "oil box",
    "oil can",
    "oil container",
    "oil containers",
    "oil dispenser",
    "oil drum",
    "oil filter",
    "oil jerry can",
    "oil jerrycan",
    "oil tin",
    "oil",
    "oilcan",
    "on deck circle",
    "onion",
    "onions",
    "open bicycle tyre",
    "opened laptop",
    "opener",
    "orange and black screwdriver",
    "orange basin",
    "orange basket",
    "orange bowl",
    "orange bucket",
    "orange buckets",
    "orange cloth",
    "orange container",
    "orange cool box",
    "orange flower pot",
    "orange jerry can",
    "orange jerrycan",
    "orange jug",
    "orange pen",
    "orange plastic jerrycan",
    "orange plate",
    "orange purse",
    "orange screw driver",
    "orange shock absorber",
    "orange torch",
    "orange towel",
    "orange wire",
    "orange",
    "oranges",
    "oreo biscuits",
    "oreo",
    "organic neem leaf capsules bottle",
    "ornament",
    "ornaments",
    "ortega taco shells",
    "orthopedic drill machine",
    "other",
    "ottoman",
    "outside mirror",
    "oven glove",
    "oven gloves",
    "oven mitt",
    "oven mitten",
    "oven mitts",
    "oven tray",
    "oven",
    "p-handle hex wrench",
    "pack of aluminum foil",
    "pack of flour",
    "pack of pasta",
    "pack of serviette",
    "pack of strawberries",
    "pack",
    "package",
    "packaging bag",
    "packaging box",
    "packed food box",
    "packer",
    "packet of cereal",
    "packet of chips",
    "packet of noodles",
    "packet paper",
    "packet",
    "pad lock",
    "paddle",
    "padlock",
    "pail",
    "pain relieving cream",
    "paint backet",
    "paint bottle",
    "paint brush",
    "paint bucket lid",
    "paint bucket",
    "paint can lid",
    "paint can",
    "paint container",
    "paint palette try",
    "paint roller plate",
    "paint roller",
    "paint scraper",
    "paint spray can",
    "paint tin",
    "paint tray",
    "paint",
    "paintbrush",
    "paintbucket",
    "painting  brush",
    "painting brush",
    "painting container",
    "painting roller",
    "painting",
    "pair of boot",
    "pair of boots",
    "pair of brown ankle boots",
    "pair of glasses",
    "pair of gloves",
    "pair of heels",
    "pair of pliers",
    "pair of scissors",
    "pair of shoes",
    "pair of slippers",
    "pair of tongs",
    "pairs of shoes",
    "pale",
    "palette knife",
    "palette",
    "pallet knife",
    "pallet",
    "palm seedling",
    "pamphlet",
    "pan lid",
    "pan",
    "pancake",
    "panga",
    "pant",
    "pape roll",
    "paper bag",
    "paper booklet",
    "paper box",
    "paper carrier bag",
    "paper clip",
    "paper clipboard",
    "paper cup",
    "paper list",
    "paper manila",
    "paper napkin",
    "paper package",
    "paper packet",
    "paper roll.",
    "paper roll",
    "paper sack",
    "paper tape",
    "paper towel roll",
    "paper towel",
    "paper towels",
    "paper",
    "papers",
    "paperwork",
    "papyrus reed",
    "papyrus reeds",
    "paraffin lamp",
    "parker.",
    "parker",
    "part of lawn mower",
    "party cups",
    "party hats",
    "party plates",
    "pasta server",
    "pastel",
    "pastry brush",
    "pastry scraper",
    "patio umbrella stand",
    "pawn",
    "peanut  pack",
    "peanut butter",
    "pears tray",
    "pears",
    "pedal litter bin",
    "pedestal fan",
    "peeler knife",
    "peeler",
    "peg",
    "pen holder",
    "pen knife",
    "pen",
    "pencil",
    "pendant fixtures",
    "penetrating catalyst bottle",
    "pepe flat cap",
    "perfume bottle",
    "perfume cane",
    "perfume",
    "person",
    "pestle",
    "pet bottle",
    "pet brush",
    "pet cage",
    "pet plate",
    "petri dish",
    "petroleum jelly",
    "phone case",
    "phone charger",
    "phone cord",
    "phone cover",
    "phone",
    "photo frame",
    "photo portait",
    "photo_album",
    "photo",
    "photocopier machine",
    "physio ball",
    "piano",
    "pick up",
    "pick-up",
    "pickle fork",
    "pickup truck",
    "pickup",
    "picnic bench",
    "picnic table",
    "picture frame",
    "picture",
    "piece of cloth.",
    "piece of cloth",
    "piece of clothe",
    "piece of material",
    "piece of paper",
    "piece of wood",
    "pieces of wood",
    "pile of clothes",
    "pile of wood",
    "pill bottle",
    "pill container",
    "pillar",
    "pillow case",
    "pillow",
    "pillows",
    "pin machine.",
    "pincers",
    "pincher",
    "pineapple",
    "pinic chair",
    "pink balloon",
    "pink bottle",
    "pink crochet hat",
    "pink hat",
    "pink jingle over seat",
    "pink pillow",
    "pink plastic bottle",
    "pink plastic container",
    "pink shopping bag",
    "pink sneakers",
    "pink towel",
    "pint tin",
    "pipe joint",
    "pipe",
    "pipette filler",
    "pizza box",
    "pizza",
    "plaid shirt",
    "plain kitchen towel",
    "plain wood",
    "plane tool",
    "plank",
    "plant bucket",
    "plant pot",
    "plant support ring",
    "plant tray",
    "plant vase",
    "plant",
    "planter",
    "planting soil",
    "planting spoon",
    "plaster",
    "plastic bag",
    "plastic bags",
    "plastic basin",
    "plastic basket tray",
    "plastic basket",
    "plastic beaker",
    "plastic bin",
    "plastic bottle.",
    "plastic bottle",
    "plastic bottles",
    "plastic bowl",
    "plastic bucket",
    "plastic busket",
    "plastic can",
    "plastic carriage bag",
    "plastic carrier bag",
    "plastic chair",
    "plastic chopping board",
    "plastic colander",
    "plastic container",
    "plastic cover",
    "plastic crate box",
    "plastic cup",
    "plastic cups",
    "plastic cylinder",
    "plastic dirt pan",
    "plastic dish plate",
    "plastic dish",
    "plastic drum",
    "plastic dust collector pan",
    "plastic dust collector",
    "plastic dustbin",
    "plastic filter",
    "plastic food container",
    "plastic glass",
    "plastic ice bag",
    "plastic jar",
    "plastic jerry can tap",
    "plastic jerry can",
    "plastic jug",
    "plastic keg",
    "plastic ladle",
    "plastic lid",
    "plastic mark pen",
    "plastic measuring cup",
    "plastic meat container",
    "plastic packaging container",
    "plastic pail",
    "plastic pan",
    "plastic paper bag",
    "plastic paper roll",
    "plastic paper",
    "plastic plant pot",
    "plastic plate rack",
    "plastic plate",
    "plastic rectangular strainer",
    "plastic remote cover",
    "plastic sachet bags",
    "plastic sack",
    "plastic saucer stand",
    "plastic scoop",
    "plastic scooper",
    "plastic serving spoon",
    "plastic sieve",
    "plastic sleeve",
    "plastic spoon",
    "plastic spray bottle",
    "plastic stool",
    "plastic strainer",
    "plastic thorny ball",
    "plastic tin",
    "plastic tool",
    "plastic toy",
    "plastic tray",
    "plastic tumbler",
    "plastic vase",
    "plastic water bottle",
    "plastic water jar",
    "plastic wrap",
    "plastic",
    "plate tray",
    "plate",
    "plates",
    "platfoam trolley",
    "platter plate",
    "platter",
    "play station control pad",
    "play station pad",
    "playing cards",
    "playstation controller",
    "playstation pad",
    "plier",
    "pliers clk",
    "pliers.",
    "pliers",
    "pliers132",
    "plies",
    "plug light",
    "plug spanner",
    "plug",
    "plunger",
    "pocket knife with scissors",
    "pocket knife",
    "point of sale",
    "pole",
    "polish can",
    "polyene",
    "polyethene bag",
    "polytene bag",
    "polytene",
    "polythene bag",
    "polythene paper bag",
    "polythene paper",
    "polythene vapour barrier",
    "polythene wrapper",
    "polythene",
    "pool chair",
    "popcorn",
    "porch bag",
    "porch light",
    "porch",
    "portable blender",
    "portable console",
    "portable fan",
    "portable inverter",
    "portable speaker",
    "portrait photo",
    "portrait",
    "pos machine",
    "pos terminal",
    "post",
    "poster",
    "pot cover",
    "pot holder cloth",
    "pot holder",
    "pot lid",
    "pot of water",
    "pot plant",
    "pot",
    "potato peeler",
    "potted plant",
    "pouch bag",
    "pouch",
    "powder milk",
    "powder scoop",
    "power adapter",
    "power bank",
    "power drill",
    "power extension",
    "power saw",
    "power screwdriver",
    "power switch",
    "power tool",
    "power wrench",
    "pressing iron",
    "pressure cooker",
    "pressure machine",
    "pressure meter",
    "pressure pump",
    "price board",
    "price post",
    "price tag",
    "pricing machine",
    "printer",
    "projector",
    "pruner",
    "pruners",
    "pruning handsaw",
    "pruning shear",
    "pruning shears",
    "pruning sheers",
    "pry bar",
    "ps pads",
    "ps remote",
    "puller slide hammer",
    "pullover",
    "pump bottle",
    "pump plier",
    "pump spray",
    "pump",
    "pumpkin",
    "purple flower pot",
    "purple flower vase",
    "purple lid",
    "purse",
    "purser",
    "push broom head",
    "push stick",
    "putty knife",
    "quick foam aerosol",
    "rachet",
    "rack",
    "racket",
    "radio",
    "raft square ruler",
    "rafter square",
    "rag cloth",
    "rag",
    "rain boots",
    "rake",
    "ramekin",
    "ramp",
    "ratchet drill",
    "ratchet screwdriver",
    "ratchet",
    "razor blade",
    "razor saw",
    "reach pole",
    "reading glasses",
    "receipt machine",
    "receipt",
    "rechargeable jump starter",
    "recipe book",
    "recoil starter",
    "rectangular door mat",
    "rectangular trowel",
    "recycling bin",
    "red and blue bottle",
    "red bag",
    "red balloon",
    "red basket",
    "red book",
    "red bowl",
    "red bucket",
    "red buckets",
    "red bull drink",
    "red car",
    "red cordless drill",
    "red crate",
    "red dough scraper",
    "red file",
    "red funnel",
    "red gallon",
    "red jerry can",
    "red jerrycan",
    "red keg",
    "red kitchen sponge",
    "red lid",
    "red metal cutter",
    "red napkin",
    "red nylon bag",
    "red oil jerrican",
    "red pepper",
    "red plastic container",
    "red plastic crate",
    "red plate",
    "red plier",
    "red pottery flower",
    "red power drill",
    "red pruning shear",
    "red purse",
    "red rag",
    "red rope",
    "red saucepan",
    "red scissors",
    "red speed square",
    "red sponge",
    "red stool",
    "red takeaway coffee cup",
    "red towel",
    "red travel bag",
    "red tray",
    "reef basket",
    "refill water bottle",
    "refrigerator",
    "regulator",
    "remort",
    "remote control",
    "remote controller",
    "remote holder",
    "remote",
    "resting bench",
    "retractable tape",
    "rice cooker pot",
    "rice cooker.",
    "rice cooker",
    "rice maker",
    "rice warmer",
    "rice washer bowl",
    "ricola",
    "right angle ruler",
    "right angle square ruler",
    "rim stip",
    "rim strip",
    "rim",
    "ring boiler",
    "ring spanner",
    "ring",
    "rip dozuki saw",
    "ripe tomato",
    "ripping pincers",
    "ritron call box",
    "road sigh",
    "roblox toy",
    "robotic vacuum cleaner",
    "rock",
    "rocking horse",
    "rod",
    "roll paper",
    "roll up mattress",
    "rolled paper",
    "roller",
    "rolling board",
    "rolling creeper",
    "rolling paper",
    "rolling pin",
    "rolling stick",
    "room heater",
    "rope pack",
    "rope",
    "rotating pipette stand",
    "roti",
    "round bottom deep frying pan",
    "round steel tray",
    "round table",
    "round tray",
    "router",
    "routine list",
    "royal blue tie",
    "rubber mallet",
    "rubber piece",
    "rubber shoe",
    "rubber shoes",
    "rubber",
    "rug",
    "rugby ball",
    "ruler",
    "sac",
    "sachet",
    "sack",
    "safety cone",
    "safety cutter",
    "safety cylinder",
    "safety glasses",
    "safety goggle",
    "safety googles",
    "safety net",
    "safety sign",
    "salad plate",
    "salt bottle",
    "salt container",
    "salt shaker",
    "salt",
    "sample bottle",
    "sand paper",
    "sandal",
    "sandals",
    "sander machine",
    "sander",
    "sanding disc",
    "sanding machine",
    "sanding rod",
    "sandle",
    "sandles",
    "sandol",
    "sandpaper disc",
    "sandpaper",
    "sandwich maker",
    "sanitizer bottle",
    "sanitizer spray",
    "sanitizer",
    "saree",
    "satellite dish",
    "sauce bottle",
    "sauce pan",
    "saucepan",
    "saucer swing",
    "saucer",
    "saw machine",
    "saw",
    "sawdust vacuum",
    "sawdust",
    "sawing machine",
    "scaff",
    "scale",
    "scalpel blade",
    "scalpel",
    "scarf",
    "scissor",
    "scissors jack",
    "scissors",
    "sconce",
    "scoop",
    "scooper",
    "scooping bowl",
    "scooping spoon",
    "scooter",
    "scoring pad",
    "scouring pad",
    "scouring powder bottle",
    "scraper mat",
    "scraper tool",
    "scraper",
    "scrapper",
    "screen",
    "screw bolt",
    "screw drill",
    "screw driver",
    "screw gun",
    "screw machine",
    "screw",
    "screwdriver machine",
    "screwdriver",
    "screwing machine",
    "scrub brush",
    "scrub sponge",
    "scrubber brush",
    "scrubber",
    "sculpture",
    "scurf",
    "sealer",
    "sealing machine",
    "seat cleaning machine",
    "seat creeper stool",
    "seat creeper",
    "seat",
    "seave",
    "secateurs",
    "security lights",
    "sedan",
    "sellotape dispenser",
    "sellotape holder",
    "sellotape.",
    "sellotape",
    "serviette box",
    "serviette holder",
    "serviette pack",
    "serviette roll",
    "serviette",
    "serviettes",
    "serving dish",
    "serving dishes",
    "serving pot",
    "serving spoon",
    "set square",
    "sewing awl",
    "shaft",
    "shampoo plastic",
    "shampoo",
    "shaped cardboard",
    "sharpening stone",
    "shawl",
    "shear",
    "shears",
    "sheath",
    "shelf basket",
    "shelf",
    "shirt",
    "shirts",
    "shock absorber",
    "shoe knife",
    "shoe needle",
    "shoe rack",
    "shoe",
    "shoes",
    "shopping bag",
    "shopping basket",
    "shopping basket====================",
    "shopping bucket",
    "shopping carrier bag",
    "shopping cart",
    "shopping courier",
    "shopping crate",
    "shopping hand cart",
    "shopping list",
    "shopping tray",
    "shopping trolley",
    "shopping_ bag",
    "shopping8 basket",
    "short",
    "shot glass",
    "shovel",
    "sickle tool",
    "sickle",
    "side lamp",
    "side mirror",
    "side plate",
    "side table",
    "sieng board",
    "sieve",
    "siever",
    "sign board",
    "sign post",
    "sign",
    "signage",
    "signpost",
    "silicone cartridge",
    "silicone",
    "silver car",
    "silver water jar",
    "silver water jug",
    "sink brush",
    "sink rack",
    "sink towel",
    "sink",
    "size marker",
    "skeleton",
    "skillet pan",
    "skillet",
    "skimmer spoon",
    "skirt",
    "skiving knife",
    "sledge hammer",
    "slice toaster",
    "slides",
    "sling bag",
    "sling shot",
    "slipper",
    "slippers",
    "slotted turner",
    "small blue dustbin",
    "small bowl",
    "small box",
    "small flower pot",
    "small pot",
    "small steel dish",
    "small wine bottle",
    "small wooden stool",
    "smart phone",
    "smart tv",
    "smartphone",
    "smoldering iron",
    "smoothening machine",
    "smoothing plane",
    "smoothing stone",
    "snack pack",
    "snack",
    "snacks",
    "snap hooks",
    "snare drum",
    "sneaker shoes",
    "sneakers",
    "soap bottle",
    "soap case",
    "soap container",
    "soap detergent",
    "soap dish bottle",
    "soap dish",
    "soap dispenser",
    "soap plate",
    "soap",
    "soccer ball",
    "socket driver",
    "socket extension",
    "socket switch",
    "socket wrench",
    "socket",
    "soda can",
    "soda",
    "sofa seat",
    "sofa set",
    "sofaset",
    "soft drink",
    "soft floor brush",
    "solder wire",
    "soldering gun",
    "soldering iron",
    "soletape",
    "solid ladle",
    "soup bowl",
    "soup scoop spoon",
    "soup spoon",
    "source tin",
    "source",
    "soy sauce",
    "soya sauce",
    "spade",
    "spaghetti  spoon",
    "spanner",
    "spark plug",
    "spatula",
    "spay bottle",
    "speaker",
    "spearmint",
    "specimen plate",
    "spectacles",
    "speed square ruler",
    "speed square",
    "spice bottle",
    "spice jar",
    "spinach",
    "spindle belt",
    "spirit level",
    "splier",
    "sponge cloth",
    "sponge scourer",
    "sponge",
    "spoon",
    "spork",
    "sport shoe",
    "sports shoes",
    "spray bottle can",
    "spray bottle.",
    "spray bottle",
    "spray can",
    "spray container",
    "spray gun",
    "spray paint",
    "spray tin",
    "spray",
    "sprayer bottle.",
    "sprayer bottle",
    "sprayer head",
    "sprayer pump",
    "sprayer tin",
    "sprayer trailer",
    "sprayer",
    "spraying bottle",
    "spraying can",
    "spricilar",
    "spring balance",
    "spring clamp",
    "spring weighing scale",
    "spring",
    "springs",
    "sprinkler bottle",
    "square  ruler",
    "square rule",
    "square ruler",
    "square tool",
    "squeeze bottle",
    "squire screw",
    "sssss",
    "stability ball",
    "stack of baskets",
    "stack plates",
    "stainless basin",
    "stainless bowl",
    "stainless coolet",
    "stainless cup",
    "stainless jar",
    "stainless lid",
    "stainless mesh basin",
    "stainless plate",
    "stainless pot",
    "stainless spoon",
    "stainless steel basin",
    "stainless steel bowl",
    "stainless steel can",
    "stainless steel dog bowl",
    "stainless steel flask",
    "stainless steel glass",
    "stainless steel plate",
    "stainless steel pot",
    "stainless stool",
    "staircase",
    "stand fan",
    "stand light lamp",
    "stand mixer",
    "stand",
    "standing fan",
    "stapler",
    "statue",
    "stay awake packets",
    "stay awake pills",
    "steak knife",
    "steam iron",
    "steel bowl",
    "steel bucket",
    "steel can",
    "steel chair",
    "steel container",
    "steel cooking pot",
    "steel cup",
    "steel dough cutter",
    "steel drum",
    "steel glass",
    "steel grate mat",
    "steel plate",
    "steel pot",
    "steel sieve",
    "steel spoon",
    "steel stand",
    "steel stool",
    "steel sufuria",
    "steel tin",
    "steel tray",
    "steel tumbler",
    "steel vegetable greator",
    "steel wire brush",
    "steel",
    "steering wheel",
    "step ladder",
    "steplar",
    "stepping stool",
    "stepstool",
    "stereo speaker",
    "stereo",
    "stick",
    "sticker paper",
    "sticker",
    "sticks",
    "sticky note pad",
    "sticky note",
    "sticky notes booklet",
    "stone",
    "stool chair",
    "stool.",
    "stool",
    "stopwatch",
    "storage basket",
    "storage box",
    "storage bucket",
    "storage container",
    "storage dish",
    "storage jar",
    "storage rack",
    "storage tin",
    "stove",
    "straightedge rule",
    "strainer bowl",
    "strainer",
    "straw",
    "street light meter box",
    "street light",
    "streetlight",
    "stretching pliers",
    "string trimmer",
    "string",
    "stroller",
    "studio light",
    "studio stool",
    "study lamp",
    "stuffed toy",
    "stuffing mix",
    "stylish indoor potted plants",
    "suction cup brush",
    "suction regulator",
    "sufuria",
    "sugar dish",
    "sugar pot",
    "sugar shovel spoon",
    "suit case",
    "suitcase",
    "sun glasses",
    "sunglasses",
    "super drum",
    "super stone",
    "supermarket baskets",
    "surface cleaner",
    "sweat shirt",
    "sweater top",
    "sweater",
    "swedish fish",
    "sweeping broom",
    "sweeping brush",
    "swig",
    "swim glass",
    "swimming floater",
    "swing set",
    "swing",
    "swipe machine",
    "swiss ball",
    "switch socket",
    "switch",
    "swivel chair",
    "syringe tube",
    "syringe",
    "syrup bottle",
    "t -wrench",
    "t grip socket spanner",
    "t handle screw driver",
    "t handle screwdriver",
    "t shirt",
    "t socket spanner",
    "t spanner",
    "t wrench",
    "t-handle screw driver",
    "t-handle screwdriver",
    "t-handled wrench",
    "t-shaped spanner",
    "t-shirt",
    "t-square",
    "t-wrench",
    "tab",
    "table accessory",
    "table calendar",
    "table clock",
    "table cloth",
    "table decor",
    "table decoration",
    "table fan",
    "table lamb",
    "table lamp",
    "table light",
    "table lump",
    "table mat",
    "table matt",
    "table napkin",
    "table plant",
    "table tennis board",
    "table vase",
    "table water",
    "table",
    "tablet phone",
    "tablet",
    "tack cloth",
    "taco shells",
    "tag",
    "take away cup",
    "takis",
    "tank",
    "tap",
    "tape dispenser",
    "tape holder",
    "tape measure tool",
    "tape measure.",
    "tape measure",
    "tape rule",
    "tape",
    "tapestry wall hanging",
    "taping knife",
    "tarp",
    "tarpaulin sheet",
    "tarpaulin",
    "tea cup",
    "tea jug",
    "tea kettle",
    "tea pack",
    "tea pot",
    "tea spoon",
    "tea towel",
    "tea urn",
    "teacup",
    "teapot",
    "teddy bear",
    "tee spanner",
    "telephone",
    "television screen",
    "television set",
    "television stand",
    "television.",
    "television",
    "televison",
    "temperature switch",
    "tennis ball",
    "tennis racket",
    "tent bag",
    "tent folder",
    "tent",
    "terminal",
    "test tube rack",
    "test tube shaker",
    "test tube",
    "test tubes",
    "tester",
    "thermaguard",
    "thermal container",
    "thermo flask",
    "thermoflask",
    "thermometer",
    "thermos flask",
    "thermos",
    "thermostat",
    "thinner bottle",
    "thrash can",
    "thread roll",
    "thread",
    "throw blanket",
    "throw pillow",
    "throw pillows",
    "thrush can",
    "tide pods",
    "tie box",
    "tie",
    "tied sack",
    "tightening nut",
    "tiles",
    "tiling glue",
    "tiling trowel",
    "timber block",
    "timber plank",
    "timber router",
    "timber saw",
    "timber",
    "timer",
    "tin can",
    "tin container",
    "tin glass",
    "tin jar",
    "tin lid",
    "tin of magarine",
    "tin of milk",
    "tin of oil",
    "tin",
    "tire pressure gauge",
    "tire ream",
    "tire",
    "tires",
    "tissue  towels",
    "tissue box",
    "tissue pack",
    "tissue paper box",
    "tissue paper roll",
    "tissue paper",
    "tissue roll",
    "tissue towel",
    "tissue wipes",
    "tissue",
    "tissues",
    "toaster",
    "toilet brush",
    "toilet paper holder",
    "toilet paper",
    "toilet roll",
    "toilet seat",
    "toilet tissue",
    "toilet",
    "token meter",
    "tomato sauce",
    "tomato",
    "tomatoes",
    "tomyum",
    "tong",
    "tool  box",
    "tool bag",
    "tool basket",
    "tool box",
    "tool bucket",
    "tool kit",
    "tool screeper stool",
    "tool tray",
    "tool",
    "toolbox",
    "toolkit",
    "tools cupboard",
    "tools plate",
    "tooth brush",
    "tooth paste",
    "toothbrush",
    "toothpaste",
    "toothpick holder",
    "toothpick",
    "toothpicks",
    "top",
    "torch light",
    "torch",
    "torchlight",
    "torque wrench",
    "tote bag",
    "touch",
    "towel paper",
    "towel tissue",
    "towel.",
    "towel",
    "towels",
    "toy ball",
    "toy car",
    "toy",
    "tp link",
    "track",
    "tractor side mirror",
    "tractor toy",
    "traffic barrier",
    "traffic cone",
    "training ball",
    "training mat",
    "transaparent plastic container",
    "transmission line tower",
    "transparent bowl",
    "transparent clothe packaging bags",
    "transparent cup",
    "transparent water bottle",
    "trash bag",
    "trash basket",
    "trash bin",
    "trash bucket",
    "trash bun",
    "trash can",
    "trash container",
    "trash tin",
    "trash",
    "trashcan",
    "travel mug",
    "traveling box",
    "travelling box",
    "tray organizer",
    "tray",
    "tree branch",
    "tree cutter",
    "tree",
    "trench coat",
    "triangle ruler",
    "triangular ruler",
    "trigger spray bottle",
    "trolley basket",
    "trolley",
    "trolly",
    "trouser",
    "trowel",
    "truck mower",
    "truck",
    "trush",
    "try square",
    "tshirt",
    "tube bulb",
    "tube holder",
    "tube",
    "tumble",
    "tumbler cup",
    "tumbler",
    "turning spatula",
    "turquoise skirt",
    "tv decoder",
    "tv remote",
    "tv",
    "tweezer",
    "tweezers",
    "twine",
    "tyre tube",
    "tyre",
    "tyres",
    "umbrella holder",
    "umbrella",
    "unsure",
    "urban bench",
    "urn",
    "usb cable",
    "usb sachets",
    "usure",
    "utensil holder",
    "utensil rack",
    "utensil towel",
    "utensils cleaning sponge",
    "utensils rack",
    "utensils rinsing soap",
    "utensils tray",
    "utility bench",
    "utility knife",
    "utility trolley cart",
    "v belt",
    "vacuum bottle",
    "vacuum cleaner nozzle",
    "vacuum cleaner's nozzle",
    "vacuum cleaner",
    "vacuum flask",
    "vacuum",
    "vase flower.",
    "vase holder",
    "vase",
    "vaseline oil",
    "vaseline",
    "vegetable oil bottle",
    "vegetable",
    "vegetables",
    "vehicle",
    "ventilation",
    "vernier caliper",
    "verse",
    "vessel",
    "vice clamp",
    "vice",
    "viscal",
    "viva tissue",
    "viva",
    "voltage controller",
    "wall art",
    "wall canvas",
    "wall censor",
    "wall chart",
    "wall clock",
    "wall decor",
    "wall décor",
    "wall decoration",
    "wall frame",
    "wall hangings",
    "wall light",
    "wall painting",
    "wall picture",
    "wall poster",
    "wall pouch",
    "wall scraper",
    "wall scrapper",
    "wall shoes shelf",
    "wall socket",
    "wall storage pocket",
    "wall switch",
    "wall-mounted paper towel dispenser",
    "wallart",
    "wallet",
    "wallpaper",
    "warm bread machine",
    "warning sigh",
    "wart all",
    "wash basin",
    "wash brush",
    "washing bar soap",
    "washing brush",
    "washing bucket",
    "washing detergent",
    "washing liquid",
    "washing machine",
    "washing powder",
    "washing sponge",
    "waste bag",
    "waste basket",
    "waste bin",
    "waste shovel",
    "watch",
    "water  bottle",
    "water barrel",
    "water bottle dispenser",
    "water bottle pack",
    "water bottle.",
    "water bottle",
    "water botttle",
    "water bowl",
    "water bucket",
    "water can",
    "water cans",
    "water clay pot",
    "water container",
    "water dispenser bottle",
    "water dispenser water bottle",
    "water dispenser",
    "water drum",
    "water glass",
    "water heater control panel",
    "water hose",
    "water jug",
    "water kettle",
    "water melons",
    "water pipe",
    "water pot",
    "water pump",
    "water spray bottle",
    "water tank",
    "water tap",
    "water",
    "watering can",
    "watermelon",
    "wattle bottle",
    "weeds",
    "weigh machine",
    "weigh scale",
    "weighing balance",
    "weighing machine",
    "weighing scale",
    "weight machine",
    "weight scale",
    "welding machine",
    "welding power box",
    "well",
    "wet floor caution board",
    "wet floor sign",
    "wheel barrow",
    "wheel cap",
    "wheel cover",
    "wheel hub",
    "wheel plate",
    "wheel rim cover",
    "wheel rim",
    "wheel",
    "wheelbarrow",
    "wheelchair",
    "wheels",
    "whine bottle",
    "whisk",
    "whisky bottle",
    "white and brown dog",
    "white bike seat",
    "white board marker",
    "white board",
    "white bottle",
    "white bowl",
    "white bucket",
    "white cap",
    "white car",
    "white cardboard box",
    "white cardboard",
    "white carton",
    "white chopping board",
    "white cloth",
    "white computer mouse",
    "white container",
    "white crate",
    "white dish",
    "white flipflop",
    "white glass mug",
    "white hanger",
    "white helmet",
    "white jerry can",
    "white jerrycan",
    "white kitchen towel",
    "white laundry basket",
    "white measuring jug",
    "white mug",
    "white oil container",
    "white paper",
    "white piece of cloth",
    "white plastic bottle.",
    "white plastic tin",
    "white plate",
    "white polythene bag",
    "white remote control",
    "white shoes",
    "white short",
    "white sneakers",
    "white stool",
    "white storage carton pack",
    "white tape",
    "white throw pillow",
    "white towel",
    "white tray",
    "whiteboard",
    "wicker basket",
    "wicker tray",
    "window frame",
    "window mesh",
    "window",
    "wine bottle",
    "wine glass",
    "wine red suv",
    "wine",
    "winnowing basket",
    "winter cap",
    "wipe cloth",
    "wipe towel",
    "wipe",
    "wiped towel",
    "wipes",
    "wiping cloth",
    "wiping spray",
    "wiping towel",
    "wire brush",
    "wire cutter",
    "wire",
    "wireless keyboard",
    "wok",
    "wood art",
    "wood block",
    "wood box",
    "wood brush",
    "wood chopping board",
    "wood clock",
    "wood craft",
    "wood cutter",
    "wood cutting machine",
    "wood frame",
    "wood glue",
    "wood laminator trimmer",
    "wood log",
    "wood pallets",
    "wood paper towel holder",
    "wood pieces",
    "wood plane",
    "wood planer",
    "wood polisher",
    "wood pusher",
    "wood router",
    "wood sander",
    "wood saw",
    "wood smoothener",
    "wood triangle ruler",
    "wood trimmer",
    "wood",
    "woodcutter",
    "wooden bench",
    "wooden box",
    "wooden chair",
    "wooden chopping board",
    "wooden cooking spoon",
    "wooden craft",
    "wooden ladder",
    "wooden ladle spoon",
    "wooden ladle",
    "wooden piece",
    "wooden sculpture",
    "wooden sign",
    "wooden spatula",
    "wooden spoon",
    "wooden staircase",
    "wooden stand",
    "wooden turner",
    "woofer speaker",
    "woofer",
    "woolen hat",
    "workout balloon",
    "workout bench",
    "workout mat",
    "workshop stool",
    "world globe",
    "woven bag",
    "woven basket",
    "woven stool",
    "wrapper",
    "wrappers",
    "wrench",
    "wrenche",
    "wrist watch",
    "wristband",
    "wristwatch",
    "writing paper.",
    "xbox pads",
    "xbox",
    "y peeler",
    "yard hoe",
    "yarn",
    "yellow bag",
    "yellow balloon",
    "yellow bicycle",
    "yellow bottle",
    "yellow bowl",
    "yellow bucket",
    "yellow cap",
    "yellow cellotape",
    "yellow chair",
    "yellow cloth",
    "yellow flour scoop",
    "yellow flower pot",
    "yellow hammer",
    "yellow jacket",
    "yellow jerrycan",
    "yellow nylon bag",
    "yellow nylon",
    "yellow paper",
    "yellow plastic bag",
    "yellow plastic container",
    "yellow polythene bag",
    "yellow pot",
    "yellow retractable knife",
    "yellow spirit level",
    "yellow sponge",
    "yellow stool",
    "yellow tin",
    "yellow toy",
    "yoga ball",
    "yoga mat",
    "yoghurt can",
    "young palm tree",
    "zero tape",
    "zero turn mower",
    "zip lock bag",
];